'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var IconWrap = (function (_ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      rest = _objectWithoutProperties(_ref, ["children", "size"]);

  var sizes = {
    "sm": {
      width: "1em",
      height: "1em"
    },
    "md": {
      width: "1.5em",
      height: "1.5em"
    },
    "lg": {
      width: "2em",
      height: "2em"
    }
  };
  return children(_objectSpread({}, sizes[size], rest));
});

var SvgAdd = function SvgAdd(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M12.889 11.111h6.222a.889.889 0 1 1 0 1.778H12.89v6.222a.889.889 0 1 1-1.778 0V12.89H4.89a.889.889 0 1 1 0-1.778h6.222V4.89a.889.889 0 1 1 1.778 0v6.222z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Add = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAdd
  }, props));
});

var SvgAlarm = function SvgAlarm(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12.003 4.543a6.431 6.431 0 1 0 0 12.862 6.431 6.431 0 0 0 0-12.862zm0-1.543a7.974 7.974 0 1 1 0 15.948 7.974 7.974 0 0 1 0-15.948zm3.772 4.905a.772.772 0 0 1 .772 1.337l-4.158 2.4a.772.772 0 1 1-.772-1.336l4.158-2.401zm-3 7.87a.772.772 0 0 1-1.544 0v-4.8a.772.772 0 0 1 1.544 0v4.8zm-6.481 4.109l-3.081-3.233a.772.772 0 0 1 1.117-1.065l3.081 3.233a.772.772 0 1 1-1.117 1.065zm11.412 0a.772.772 0 1 1-1.117-1.065l3.08-3.233a.772.772 0 1 1 1.118 1.065l-3.08 3.233z",
    id: "alarm_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 23.123)",
    xlinkHref: "#alarm_svg__a"
  })));
};

var Alarm = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAlarm
  }, props));
});

var SvgAnimationNext = function SvgAnimationNext(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M5 5.5a1 1 0 0 1 2 0v13a1 1 0 1 1-2 0v-13zM10 18.391a1 1 0 0 0 1.518.856l9.153-5.536c1.286-.779 1.286-2.645 0-3.423l-9.153-5.536a1 1 0 1 0-1.036 1.711l8.446 5.109a.5.5 0 0 1 0 .855l-8.446 5.109a1 1 0 0 0-.482.855z",
    fill: "currentColor"
  }));
};

var AnimationNext = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAnimationNext
  }, props));
});

var SvgAnimationPrevious = function SvgAnimationPrevious(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M19 18.5a1 1 0 1 1-2 0v-13a1 1 0 1 1 2 0v13zM14 5.609a1 1 0 0 0-1.518-.856L3.33 10.29c-1.286.779-1.286 2.645 0 3.423l9.154 5.536a1 1 0 1 0 1.034-1.711l-8.445-5.108a.5.5 0 0 1 0-.856l8.445-5.109A1 1 0 0 0 14 5.61z",
    fill: "currentColor"
  }));
};

var AnimationPrevious = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAnimationPrevious
  }, props));
});

var SvgAnnotations = function SvgAnnotations(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12.273 4.001a.316.316 0 0 0-.14.05s-2.026 1.311-4.046 3.09c-1.01.889-2.017 1.893-2.785 2.93-.767 1.036-1.31 2.106-1.302 3.15 0 .5.21.899.49 1.169.283.27.626.422.942.56.317.137.609.262.792.39.182.127.25.204.25.4 0 .076-.074.242-.23.44-.157.197-.376.425-.611.67-.472.49-.913 1.095-.913 1.842 0 .353.035.618.242.817.206.199.492.41.73.435.612.065.865.065.865.065.328 0 .366-.164.427-.332s-.094-.427-.27-.422c.155 0-.597.011-.813-.058-.023-.007-.238-.024-.387-.432-.122-.335.14-.79.598-1.268.23-.239.192-.11.773-.874.58-.764.591-1.42.23-1.673a3.66 3.66 0 0 0-.81-.454c-.301-.13-.823-.38-1.003-.552-.18-.173-.37-.428-.37-.808-.008-.812.342-1.533 1.067-2.512.724-.979 1.69-1.967 2.679-2.838a53.118 53.118 0 0 1 3.93-3.12c.126-.079.047-.308 0-.448A.32.32 0 0 0 12.273 4zM18.83 8.28a.835.835 0 0 0-.605.156l-.551.5 1.551 1.569.556-.516c.145-.195.185-.372.185-.652a.967.967 0 0 0-.29-.691c-.257-.256-.606-.342-.846-.366zm-1.534 1.034L8.764 17.84c-.102.07-.212.362-.226.423l-.302 1.318c-.021.13-.039.192.026.255s.173.06.276.042l1.415-.41a1.06 1.06 0 0 0 .297-.158l8.556-8.446-.513-.535-.395-.399-.602-.616z",
    id: "annotations_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M2 2h21v21H2z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "annotations_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#annotations_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#annotations_svg__a"
  }), React.createElement("g", {
    mask: "url(#annotations_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Annotations = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAnnotations
  }, props));
});

var SvgArrow = function SvgArrow(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47 4.47a.75.75 0 0 0 0 1.06L16.86 17.922H15.07a.692.692 0 0 0 0 1.384h3.524c.383 0 .693-.31.693-.692v-3.525a.692.692 0 1 0-1.385 0v1.752L5.53 4.47a.75.75 0 0 0-1.06 0z",
    fill: "currentColor"
  }));
};

var Arrow = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgArrow
  }, props));
});

var SvgAttachment = function SvgAttachment(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.583 12.35a.75.75 0 1 1-1.037-1.085l.981-.938.961-.918.044-.042.866-.827c1.573-1.502 2.272-2.17 3.143-2.999 1.375-1.31 3.35-1.657 5.052-.884 1.699.772 2.731 2.464 2.653 4.354-.05 1.197-.518 2.242-1.381 3.056a1895.844 1895.844 0 0 1-7.304 6.851 3.448 3.448 0 0 1-4.89-.181c-1.274-1.372-.946-3.513.506-4.885 1.156-1.093 2.083-1.964 4.171-3.922a2829.681 2829.681 0 0 0 3.024-2.835c.952-.879 2.316-.75 3.091.091.773.838.765 2.055-.185 2.939L10.923 15.1l-.315.292-.355.33-.033.03c-.044.04-.202.177-.204.179a.75.75 0 0 1-.99-1.126l.187-.165.374-.347.315-.292c2.59-2.405 3.857-3.583 5.354-4.975.33-.306.331-.577.105-.823-.237-.256-.657-.296-.971-.006-.249.23-.447.416-.891.834l-.387.364-1.738 1.63a1177.501 1177.501 0 0 0-4.167 3.917c-.902.854-1.09 2.072-.437 2.774a1.948 1.948 0 0 0 2.768.105c2.394-2.233 4.823-4.512 7.298-6.846.575-.543.878-1.216.911-2.026.053-1.282-.634-2.408-1.775-2.927-1.141-.518-2.462-.286-3.396.605L9.447 9.612l-.88.84-.043.042-.96.917-.981.939z",
    id: "attachment_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M2 2h21v21H2z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#attachment_svg__a"
  })));
};

var Attachment = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAttachment
  }, props));
});

var SvgAudioOff = function SvgAudioOff(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M10.51 5.826L9.294 4.702A3 3 0 0 1 15 6v3.978L13.5 8.59V6a1.5 1.5 0 0 0-2.99-.174zm-.01 4.64V12a1.5 1.5 0 0 0 2.672.936l1.103 1.02A3 3 0 0 1 9 12V9.08l1.5 1.386zm5.017 4.638l.745.689a.749.749 0 0 1-.246.62c-.845.758-1.94 1.19-3.266 1.305v1.842c0 .066-.008.13-.024.19h.774a.75.75 0 1 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.774a.751.751 0 0 1-.024-.19v-1.842c-2.709-.237-4.42-1.797-4.985-4.568a.75.75 0 0 1 1.47-.3c.471 2.314 1.828 3.4 4.265 3.4 1.32 0 2.312-.324 3.013-.953a.747.747 0 0 1 .504-.193zM5.966 4.912a.645.645 0 0 1 0-.963.78.78 0 0 1 1.04 0l11.778 10.89a.645.645 0 0 1 0 .962.78.78 0 0 1-1.04 0L5.965 4.91z",
    id: "audio-off_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "audio-off_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#audio-off_svg__a"
  })), React.createElement("use", {
    fill: "#2B3C41",
    fillRule: "nonzero",
    xlinkHref: "#audio-off_svg__a"
  }), React.createElement("g", {
    mask: "url(#audio-off_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var AudioOff = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAudioOff
  }, props));
});

var SvgAudioOn = function SvgAudioOn(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 4.5A1.5 1.5 0 0 0 10.5 6v6a1.5 1.5 0 0 0 3 0V6A1.5 1.5 0 0 0 12 4.5zm-.726 15.25a.751.751 0 0 1-.024-.19v-1.842c-2.709-.237-4.42-1.797-4.985-4.568a.75.75 0 0 1 1.47-.3c.471 2.314 1.828 3.4 4.265 3.4 2.437 0 3.794-1.086 4.265-3.4a.75.75 0 1 1 1.47.3c-.565 2.771-2.276 4.33-4.985 4.568v1.842c0 .066-.008.13-.024.19h.774a.75.75 0 1 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.774zM12 3a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3z",
    id: "audio-on_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "audio-on_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#audio-on_svg__a"
  })), React.createElement("use", {
    fill: "#2B3C41",
    fillRule: "nonzero",
    xlinkHref: "#audio-on_svg__a"
  }), React.createElement("g", {
    mask: "url(#audio-on_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var AudioOn = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgAudioOn
  }, props));
});

var SvgBack = function SvgBack(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M8.01 11.05H18a.75.75 0 1 1 0 1.5H7.61l2.92 2.92a.75.75 0 0 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-2.52 2.52z",
    id: "back_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "back_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#back_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#back_svg__a"
  }), React.createElement("g", {
    mask: "url(#back_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Back = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgBack
  }, props));
});

var SvgCalendar = function SvgCalendar(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6 6.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5H6zM6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm2-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1zm8 1.5a.5.5 0 0 0 .5-.5v2a.5.5 0 1 0-1 0V5a.5.5 0 0 0 .5.5zM16 4a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1zM4.926 10.745v-1.5h13.7v1.5h-13.7z",
    id: "calendar_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "calendar_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#calendar_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#calendar_svg__a"
  }), React.createElement("g", {
    mask: "url(#calendar_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Calendar = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCalendar
  }, props));
});

var SvgCaretDown = function SvgCaretDown(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M15.47 9.47a.75.75 0 0 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06L12 12.94l3.47-3.47z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var CaretDown = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCaretDown
  }, props));
});

var SvgCaretLeft = function SvgCaretLeft(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M14.53 15.47a.75.75 0 0 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06L11.06 12l3.47 3.47z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var CaretLeft = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCaretLeft
  }, props));
});

var SvgCaretRight = function SvgCaretRight(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M9.47 8.53a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L12.94 12 9.47 8.53z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var CaretRight = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCaretRight
  }, props));
});

var SvgCaretUp = function SvgCaretUp(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M8.53 14.53a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L12 11.06l-3.47 3.47z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var CaretUp = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCaretUp
  }, props));
});

var SvgCategory = function SvgCategory(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M4.5 7.5v9h13.324l3.669-4.5-3.669-4.5H4.5zm0-1.5h13.324a1.5 1.5 0 0 1 1.163.552l3.668 4.5a1.5 1.5 0 0 1 0 1.896l-3.668 4.5a1.5 1.5 0 0 1-1.163.552H4.5A1.5 1.5 0 0 1 3 16.5v-9A1.5 1.5 0 0 1 4.5 6z",
    id: "category_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    opacity: 0.4,
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "scale(1 -1) rotate(30 57.781 0)",
    xlinkHref: "#category_svg__a"
  })));
};

var Category = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCategory
  }, props));
});

var SvgCheck = function SvgCheck(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M17.469 7.47a.75.75 0 0 1 1.062 1.06l-8.378 8.4a.75.75 0 0 1-1.067-.005l-3.622-3.696a.75.75 0 0 1 1.072-1.05l3.09 3.154L17.47 7.47z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Check = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCheck
  }, props));
});

var SvgCheckOutlined = function SvgCheckOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M10.077 14.254l5.989-6.03A.75.75 0 0 1 17.13 9.28l-6.518 6.563a.75.75 0 0 1-1.061.002l-2.828-2.815a.75.75 0 0 1 1.059-1.063l2.295 2.286zM12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm0 1.5C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z",
    fillRule: "nonzero",
    fill: "currentColor"
  }));
};

var CheckOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCheckOutlined
  }, props));
});

var SvgClock = function SvgClock(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 5.548a6.452 6.452 0 1 0 0 12.904 6.452 6.452 0 0 0 0-12.904zM12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm3.785 4.92a.774.774 0 0 1 .774 1.342l-4.172 2.408a.774.774 0 0 1-.774-1.34l4.172-2.41zm-3.01 7.897a.774.774 0 1 1-1.55 0V12a.774.774 0 1 1 1.55 0v4.817z",
    id: "clock_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(-60 12 12)",
    xlinkHref: "#clock_svg__a"
  })));
};

var Clock = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgClock
  }, props));
});

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M13.257 12l4.4 4.4a.889.889 0 1 1-1.257 1.257l-4.4-4.4-4.399 4.4A.889.889 0 1 1 6.344 16.4l4.399-4.399-4.4-4.4A.889.889 0 1 1 7.6 6.346l4.4 4.4 4.4-4.4a.889.889 0 1 1 1.257 1.257l-4.4 4.4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Close = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgClose
  }, props));
});

var SvgClosedCaptionActiveOutlined = function SvgClosedCaptionActiveOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 5.625a3 3 0 0 1 3-3h12.75a3 3 0 0 1 3 3v12.75a3 3 0 0 1-3 3H5.625a3 3 0 0 1-3-3V5.625z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 8.875H8.875a2.5 2.5 0 0 0-2.5 2.5v1.25a2.5 2.5 0 0 0 2.5 2.5h1.875",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M10.75 8.875H8.875a2.5 2.5 0 0 0-2.5 2.5v1.25a2.5 2.5 0 0 0 2.5 2.5h1.875",
    stroke: "#536872",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.875h-1.875a2.5 2.5 0 0 0-2.5 2.5v1.25a2.5 2.5 0 0 0 2.5 2.5H17",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M17 8.875h-1.875a2.5 2.5 0 0 0-2.5 2.5v1.25a2.5 2.5 0 0 0 2.5 2.5H17",
    stroke: "#536872",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var ClosedCaptionActiveOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgClosedCaptionActiveOutlined
  }, props));
});

var SvgClosedCaptionInactiveOutlined = function SvgClosedCaptionInactiveOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M5.125 1.75A3.375 3.375 0 0 0 1.75 5.125v13.75a3.375 3.375 0 0 0 3.375 3.375h13.75a3.375 3.375 0 0 0 3.375-3.375V5.125a3.375 3.375 0 0 0-3.375-3.375H5.125zM3.5 5.125c0-.897.728-1.625 1.625-1.625h13.75c.898 0 1.625.728 1.625 1.625v13.75c0 .898-.727 1.625-1.625 1.625H5.125A1.625 1.625 0 0 1 3.5 18.875V5.125z",
    fill: "#fff",
    stroke: "#536872",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.875 8A3.375 3.375 0 0 0 5.5 11.375v1.25A3.375 3.375 0 0 0 8.875 16h1.875a.875.875 0 0 0 0-1.75H8.875a1.625 1.625 0 0 1-1.625-1.625v-1.25c0-.898.728-1.625 1.625-1.625h1.875a.875.875 0 0 0 0-1.75H8.875zM15.125 8a3.375 3.375 0 0 0-3.375 3.375v1.25A3.375 3.375 0 0 0 15.125 16H17a.875.875 0 0 0 0-1.75h-1.875a1.625 1.625 0 0 1-1.625-1.625v-1.25c0-.898.727-1.625 1.625-1.625H17A.875.875 0 0 0 17 8h-1.875z",
    fill: "#fff",
    stroke: "#536872",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var ClosedCaptionInactiveOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgClosedCaptionInactiveOutlined
  }, props));
});

var SvgComment = function SvgComment(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.695 16.908a.936.936 0 0 0 .003-.028l-.003.028zm-.563-.336c-1.441-1.18-2.328-2.78-2.464-4.542-.304-3.957 3.244-7.395 7.858-7.75a9.945 9.945 0 0 1 1.966.042c3.795.462 6.73 3.08 6.986 6.415a6.12 6.12 0 0 1-.124 1.778c-.702 3.215-3.885 5.677-7.735 5.973a9.955 9.955 0 0 1-2.05-.053c-1.138 1.03-2.722 1.422-4.382 1.433-.916.007-1.186-1.25-.345-1.615.318-.138.587-.474.746-.907.047-.127.08-.253.097-.36a7.868 7.868 0 0 1-.553-.414zm7.179-10.76a8.445 8.445 0 0 0-1.67-.037c-3.843.296-6.713 3.077-6.477 6.14.103 1.34.784 2.567 1.919 3.497.211.174.437.336.676.485.607.378.547 1.38.1 2.272.748-.188 1.404-.515 1.87-1.009a.769.769 0 0 1 .708-.262 8.416 8.416 0 0 0 2.067.095c3.222-.248 5.832-2.267 6.384-4.798a4.62 4.62 0 0 0 .094-1.343c-.197-2.568-2.542-4.66-5.671-5.04zM9 13.75a.75.75 0 1 1 0-1.5h5.835a.75.75 0 0 1 0 1.5H9zm0-3a.75.75 0 1 1 0-1.5h5.835a.75.75 0 0 1 0 1.5H9z",
    id: "comment_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "comment_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#comment_svg__a"
  })), React.createElement("use", {
    fill: "#263C42",
    fillRule: "nonzero",
    xlinkHref: "#comment_svg__a"
  }), React.createElement("g", {
    mask: "url(#comment_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Comment = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgComment
  }, props));
});

var SvgCopy = function SvgCopy(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M19.64 8.587h-4.392a.68.68 0 0 1-.68-.68V3.36H8.527L8.36 17.65c0 .375-.268.907-.644.907-.375 0-.716-.532-.716-.907l.167-14.97a.68.68 0 0 1 .68-.68h7.646a.68.68 0 0 1 .465.183l4.827 4.514a.68.68 0 0 1 .215.497v10.683a.68.68 0 0 1-.68.68H7.847c-.376 0-.167-.532-.167-.907l-.513-2.664a.68.68 0 0 1 .68-.68c.25 0 .421.964.513 2.891h11.28v-8.61zm-.28-1.36l-3.432-3.21v3.21h3.432zm-2.575 10.47a.68.68 0 0 1 .215.497v2.683a.68.68 0 0 1-.68.68H3.71a.68.68 0 0 1-.679-.68v-2.891a.68.68 0 1 1 1.36 0v2.211h11.25V18.49l1.144-.792zM7.225 6.36H4.527L4.36 20.65a.68.68 0 1 1-1.36 0l.167-14.97a.68.68 0 0 1 .68-.68h3.646a.68.68 0 0 1 .465.183L7.225 6.36z",
    id: "copy_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#copy_svg__a"
  })));
};

var Copy = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCopy
  }, props));
});

var SvgCorporation = function SvgCorporation(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12.742 4.5h.801a1 1 0 0 1 1 1v.294h.57a1 1 0 0 1 1 1V8.36H17a1 1 0 0 1 1 1v11.275h2a.75.75 0 1 1 0 1.5H4a.75.75 0 1 1 0-1.5h2V9.361a1 1 0 0 1 1-1h.887V6.794a1 1 0 0 1 1-1h.57V5.5a1 1 0 0 1 1-1h.785V2.961a.75.75 0 0 1 1.5 0V4.5zm-2.898 16V19a1 1 0 0 1 1-1h2.312a1 1 0 0 1 1 1v1.5H16.5V9.861h-9V20.5h2.344zM9.387 7.294v1h5.226v-1H9.387zm-.01 7.503a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0-2.462a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0 4.924a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM12 14.797a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0-2.462a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0 4.924a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm2.623-2.493a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0-2.43a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0 4.923a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z",
    id: "corporation_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "corporation_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#corporation_svg__a"
  })), React.createElement("use", {
    fill: "#92A2AB",
    fillRule: "nonzero",
    xlinkHref: "#corporation_svg__a"
  }), React.createElement("g", {
    mask: "url(#corporation_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Corporation = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgCorporation
  }, props));
});

var SvgDataSource = function SvgDataSource(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M18.746 8.008c-1.419 1.09-3.924 1.76-6.746 1.76-2.822 0-5.327-.67-6.746-1.76V9.97c0 1.331 2.983 2.657 6.746 2.657 3.763 0 6.746-1.326 6.746-2.657V8.008zm1.226-2.124v12.384c0 .06-.009.118-.025.173C19.623 20.548 16.155 22 12 22s-7.623-1.452-7.947-3.559a.613.613 0 0 1-.025-.173V5.884C4.028 3.603 7.635 2 12 2s7.972 1.603 7.972 3.884zm-1.226 12.232v-1.818c-1.419 1.09-3.924 1.76-6.746 1.76-2.822 0-5.327-.67-6.746-1.76v1.818c0 1.332 2.983 2.658 6.746 2.658 3.763 0 6.746-1.326 6.746-2.658zm0-3.942v-2.08c-1.419 1.09-3.924 1.76-6.746 1.76-2.822 0-5.327-.67-6.746-1.76v2.08c0 1.332 2.983 2.657 6.746 2.657 3.763 0 6.746-1.325 6.746-2.657zM12 8.541c3.763 0 6.746-1.325 6.746-2.657S15.763 3.226 12 3.226c-3.763 0-6.746 1.326-6.746 2.658C5.254 7.216 8.237 8.54 12 8.54z",
    id: "data-source_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "data-source_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#data-source_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#data-source_svg__a"
  }), React.createElement("g", {
    mask: "url(#data-source_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var DataSource = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgDataSource
  }, props));
});

var SvgDocCenter = function SvgDocCenter(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.25 5.5c0-.5-.212-1-1.25-1H3.5v13.05H9c-.027 0 2.25 0 2.25.5V5.5zM2.5 3.033H10c1.038 0 2 0 2 1.467v16.482C11.355 19.66 10.364 19 9.027 19H2.5a.5.5 0 0 1-.5-.5V3.533a.5.5 0 0 1 .5-.5zm10.25 2.434v12.55c0-.5 2.277-.5 2.25-.5h5.5V4.468H14c-1.038 0-1.25.5-1.25 1zM21.5 3a.5.5 0 0 1 .5.5v14.967a.5.5 0 0 1-.5.5h-6.527c-1.337 0-2.328.66-2.973 1.982V4.467C12 3 12.962 3 14 3h7.5z",
    id: "doc-center_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "doc-center_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#doc-center_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#doc-center_svg__a"
  }), React.createElement("g", {
    mask: "url(#doc-center_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var DocCenter = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgDocCenter
  }, props));
});

var SvgDocumentArticle = function SvgDocumentArticle(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M14.153 4.5H6.5v15.874h11.944V8.671h-3.541a.75.75 0 0 1-.75-.75V4.5zm1.5.85v1.82h1.78l-1.78-1.82zM5 3.75A.75.75 0 0 1 5.75 3h9.388a.75.75 0 0 1 .537.226l4.055 4.15a.75.75 0 0 1 .214.524v13.224a.75.75 0 0 1-.75.75H5.75a.75.75 0 0 1-.75-.75V3.75zm3.373 13.374a.75.75 0 1 1 0-1.5h7.517a.75.75 0 0 1 0 1.5H8.373zM13.75 11.5a.75.75 0 1 1 0-1.5h1.921a.75.75 0 0 1 0 1.5H13.75zm0 3a.75.75 0 1 1 0-1.5h1.921a.75.75 0 0 1 0 1.5H13.75zm-4.721-3.57v2.074h1.911v-2.075H9.03zm-.478-1.556h2.867c.528 0 .955.464.955 1.037v3.111c0 .573-.427 1.037-.955 1.037H8.55c-.527 0-.955-.464-.955-1.037v-3.111c0-.573.428-1.037.955-1.037z",
    id: "document-article_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "document-article_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#document-article_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#document-article_svg__a"
  }), React.createElement("g", {
    mask: "url(#document-article_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var DocumentArticle = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgDocumentArticle
  }, props));
});

var SvgDocumentDefault = function SvgDocumentDefault(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.78 4.126H6.127V20H18.07V8.297h-3.54a.75.75 0 0 1-.75-.75v-3.42zm1.5.85v1.821h1.779l-1.78-1.82zm-10.653-1.6a.75.75 0 0 1 .75-.75h9.388a.75.75 0 0 1 .536.226l4.056 4.15a.75.75 0 0 1 .213.525V20.75a.75.75 0 0 1-.75.75H5.377a.75.75 0 0 1-.75-.75V3.376zM8 10.75a.75.75 0 1 1 0-1.5h7.517a.75.75 0 1 1 0 1.5H8zm0 3a.75.75 0 1 1 0-1.5h7.517a.75.75 0 1 1 0 1.5H8zm0 3a.75.75 0 1 1 0-1.5h7.517a.75.75 0 1 1 0 1.5H8zm0-9a.75.75 0 0 1 0-1.5h2.921a.75.75 0 0 1 0 1.5H8z",
    id: "document-default_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "document-default_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#document-default_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#document-default_svg__a"
  }), React.createElement("g", {
    mask: "url(#document-default_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var DocumentDefault = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgDocumentDefault
  }, props));
});

var SvgDocumentExternal = function SvgDocumentExternal(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.78 4.126H6.127V20H18.07V8.297h-3.54a.75.75 0 0 1-.75-.75v-3.42zm1.5.85v1.821h1.779l-1.78-1.82zm-10.653-1.6a.75.75 0 0 1 .75-.75h9.388a.75.75 0 0 1 .536.226l4.056 4.15a.75.75 0 0 1 .213.525V20.75a.75.75 0 0 1-.75.75H5.377a.75.75 0 0 1-.75-.75V3.376zm7.138 12.064c.277 0 .502.23.502.513a.508.508 0 0 1-.502.514 3.506 3.506 0 0 1-3.184-2.072 3.658 3.658 0 0 1 .49-3.827l-.575-.007A.508.508 0 0 1 8 10.04a.506.506 0 0 1 .147-.365.483.483 0 0 1 .36-.142l2.009.023a.488.488 0 0 1 .179.039.481.481 0 0 1 .048.028c.037.019.072.043.104.071.086.09.142.207.156.333.002.015.009.028.009.043v2.03a.508.508 0 0 1-.502.514.508.508 0 0 1-.502-.514V11.05a2.603 2.603 0 0 0-.567 2.8 2.502 2.502 0 0 0 2.324 1.59zm3.736-.534c.277.002.5.233.499.517a.508.508 0 0 1-.505.51h-.005l-2.007-.023a.487.487 0 0 1-.179-.038.479.479 0 0 1-.048-.029.49.49 0 0 1-.103-.071.49.49 0 0 1-.044-.051.451.451 0 0 1-.09-.164.182.182 0 0 1-.023-.118c-.001-.015-.009-.028-.009-.043v-2.03c0-.284.225-.514.502-.514s.502.23.502.513v1.053a2.604 2.604 0 0 0 .566-2.8 2.5 2.5 0 0 0-2.322-1.59.508.508 0 0 1-.502-.514c0-.284.225-.514.502-.514 1.364-.001 2.604.807 3.182 2.072a3.66 3.66 0 0 1-.49 3.827l.574.007z",
    id: "document-external_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "document-external_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#document-external_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#document-external_svg__a"
  }), React.createElement("g", {
    mask: "url(#document-external_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var DocumentExternal = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgDocumentExternal
  }, props));
});

var SvgDownload = function SvgDownload(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M8.25 13.364V1a.75.75 0 0 1 1.5 0v12.364l3.76-3.24a.75.75 0 1 1 .98 1.137l-5 4.307a.75.75 0 0 1-.98 0l-5-4.307a.75.75 0 0 1 .98-1.137l3.76 3.24zM1 18.75a.75.75 0 1 1 0-1.5h16a.75.75 0 1 1 0 1.5H1z",
    id: "download_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("g", {
    transform: "translate(3 2)"
  }, React.createElement("mask", {
    id: "download_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#download_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#download_svg__a"
  }), React.createElement("g", {
    mask: "url(#download_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M-3-2h24v24H-3z"
  })))));
};

var Download = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgDownload
  }, props));
});

var SvgEdit = function SvgEdit(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.024 4.296l-3.32-3.32c-.255-.255-.68-.242-.951.028L1.33 10.426a.72.72 0 0 0-.202.39l-.667 3.986a.63.63 0 0 0 .735.736l3.987-.667a.72.72 0 0 0 .39-.202l9.422-9.422c.27-.27.283-.696.028-.95zm-2.811 1.889l1.37-1.37-2.397-2.399-1.371 1.37 2.398 2.399zm-3.377-1.42l2.398 2.399-5.483 5.483-2.398-2.398 5.483-5.483zm-6.9 9.299l.47-2.805 2.335 2.336-2.805.469z",
    fill: "currentColor"
  }));
};

var Edit = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgEdit
  }, props));
});

var SvgEmail = function SvgEmail(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M16.5 2.655l-6.982 7.843a.748.748 0 0 1-.562.25.748.748 0 0 1-.562-.25L1.5 2.754V14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V2.655zM15.52 1.5H2.392l6.564 7.373L15.52 1.5zM2 0h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    id: "email_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("g", {
    transform: "translate(3 4)"
  }, React.createElement("mask", {
    id: "email_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#email_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#email_svg__a"
  }), React.createElement("g", {
    mask: "url(#email_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M-3-4h24v24H-3z"
  })))));
};

var Email = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgEmail
  }, props));
});

var SvgEmailBlast = function SvgEmailBlast(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M5.5 13.241V20.2a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V13a.51.51 0 0 0 0-.012l-4.843 3.888c-.987.987-2.587.987-3.51.057L5.5 13.241zm11.215-.741h-9.74l4.168 3.315c.401.402 1.052.402 1.514-.054l4.058-3.261zM6 11h12a2 2 0 0 1 2 2v7.2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2zm-.81-2.773v.248a.6.6 0 1 1-1.2 0V6.808a.6.6 0 0 1 .6-.6h1.667a.6.6 0 1 1 0 1.2h-.189l1.676 1.676a.6.6 0 0 1-.848.849L5.19 8.227zm12.742-.819h-.182a.6.6 0 0 1 0-1.2h1.667a.6.6 0 0 1 .6.6v1.667a.6.6 0 0 1-1.2 0V8.22l-1.713 1.713a.6.6 0 1 1-.848-.849l1.676-1.676zM11.6 4.72L10.431 5.89a.6.6 0 1 1-.848-.849l2.121-2.121a.6.6 0 0 1 .849 0l2.121 2.121a.6.6 0 1 1-.849.849L12.8 4.863v4.302a.6.6 0 0 1-1.2 0V4.72z",
    fill: "currentColor"
  }));
};

var EmailBlast = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgEmailBlast
  }, props));
});

var SvgErrorFilled = function SvgErrorFilled(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 88 88"
  }, props), React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, React.createElement("circle", {
    cx: 43.636,
    cy: 43.636,
    r: 43.636
  }), React.createElement("circle", {
    cx: 43.636,
    cy: 43.636,
    r: 43.636
  }), React.createElement("circle", {
    cx: 43.636,
    cy: 43.636,
    r: 43.636
  }), React.createElement("path", {
    d: "M41.26 46.187l-.796-11.928c-.15-2.324-.224-3.993-.224-5.006 0-1.378.36-2.452 1.083-3.224.722-.772 1.673-1.158 2.851-1.158 1.428 0 2.383.493 2.864 1.481.482.988.722 2.412.722 4.271 0 1.096-.058 2.208-.174 3.337l-1.07 12.277c-.117 1.46-.366 2.581-.748 3.362-.382.78-1.013 1.17-1.893 1.17-.896 0-1.519-.378-1.867-1.133-.349-.755-.598-1.905-.747-3.449zm2.765 16.386a3.919 3.919 0 0 1-2.652-.984c-.756-.656-1.133-1.573-1.133-2.752 0-1.029.36-1.905 1.083-2.627.722-.722 1.606-1.083 2.652-1.083s1.938.361 2.677 1.083c.739.722 1.108 1.598 1.108 2.627 0 1.163-.373 2.076-1.12 2.74a3.813 3.813 0 0 1-2.615.996z",
    fill: "currentColor"
  })));
};

var ErrorFilled = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgErrorFilled
  }, props));
});

var SvgErrorOutlined = function SvgErrorOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M10.95 15.843c0-.281.098-.52.294-.715a.953.953 0 0 1 .697-.294c.281 0 .52.098.716.294a.974.974 0 0 1 .293.715c0 .27-.098.502-.293.698a.974.974 0 0 1-.716.293.953.953 0 0 1-.697-.293.953.953 0 0 1-.294-.698zm.165-8.56a.792.792 0 0 1 .725-.632.762.762 0 0 1 .45.136.865.865 0 0 1 .33.448v5.522c-.012.235-.092.414-.239.536a.779.779 0 0 1-.486.193.78.78 0 0 1-.495-.16c-.153-.113-.248-.286-.285-.52V7.282z"
  }), React.createElement("path", {
    d: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm0 1.5C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
  })));
};

var ErrorOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgErrorOutlined
  }, props));
});

var SvgExit = function SvgExit(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M17.583 11.2l-2.305-1.867a.75.75 0 1 1 .944-1.166l3.805 3.081a.75.75 0 0 1 .016 1.153l-3.805 3.259a.75.75 0 0 1-.976-1.14l2.126-1.82H9.75a.75.75 0 1 1 0-1.5h7.833zM13 19.75a.75.75 0 1 1 0 1.5H4.5a.75.75 0 0 1-.75-.75v-17a.75.75 0 0 1 .75-.75H13a.75.75 0 1 1 0 1.5H5.25v15.5H13z",
    id: "exit_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "exit_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#exit_svg__a"
  })), React.createElement("use", {
    fill: "#2B3C41",
    xlinkHref: "#exit_svg__a"
  }), React.createElement("g", {
    mask: "url(#exit_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Exit = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgExit
  }, props));
});

var SvgExitFullScreenOutlined = function SvgExitFullScreenOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 8.727a.818.818 0 0 1-.818.818h-4.91a.818.818 0 0 1-.818-.818V3.818a.818.818 0 0 1 1.637 0V7.91h4.09c.453 0 .819.366.819.818zm-11.455 0a.818.818 0 0 1-.818.818H3.818a.818.818 0 1 1 0-1.636H7.91V3.82a.818.818 0 1 1 1.636 0v4.908zM8.727 21a.818.818 0 0 1-.818-.818V16.09H3.82a.818.818 0 1 1 0-1.637h4.908c.452 0 .818.367.818.819v4.909a.818.818 0 0 1-.818.818zm6.546 0a.818.818 0 0 1-.819-.818v-4.91c0-.451.367-.818.819-.818h4.909a.818.818 0 0 1 0 1.637H16.09v4.09a.818.818 0 0 1-.818.819z",
    fill: "#fff"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 8.727c0 .728-.59 1.319-1.318 1.319h-4.91c-.727 0-1.318-.59-1.318-1.319V3.818a1.318 1.318 0 0 1 2.637 0V7.41h3.59c.729 0 1.319.59 1.319 1.318zm-11.454 0c0 .728-.59 1.319-1.319 1.319H3.818a1.318 1.318 0 0 1 0-2.637H7.41V3.82a1.318 1.318 0 0 1 2.637 0v4.908zM8.727 21.5c-.728 0-1.318-.59-1.318-1.318V16.59H3.82a1.318 1.318 0 0 1 0-2.637h4.908c.728 0 1.319.59 1.319 1.319v4.909c0 .728-.59 1.318-1.319 1.318zm6.546 0c-.728 0-1.319-.59-1.319-1.318v-4.91c0-.727.59-1.318 1.319-1.318h4.909a1.318 1.318 0 0 1 0 2.637H16.59v3.59c0 .729-.59 1.319-1.318 1.319zm4.909-11.955a.818.818 0 1 0 0-1.636H16.09V3.82a.818.818 0 1 0-1.637 0v4.908c0 .452.367.818.819.818h4.909zm-11.455 0a.818.818 0 0 0 .818-.818V3.818a.818.818 0 1 0-1.636 0V7.91H3.82a.818.818 0 1 0 0 1.636h4.908zM7.91 20.182a.818.818 0 1 0 1.636 0v-4.91a.818.818 0 0 0-.818-.818H3.818a.818.818 0 0 0 0 1.637H7.91v4.09zm6.545 0a.818.818 0 0 0 1.637 0V16.09h4.09a.818.818 0 1 0 0-1.637h-4.908a.818.818 0 0 0-.819.819v4.909z",
    fill: "#536872"
  }));
};

var ExitFullScreenOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgExitFullScreenOutlined
  }, props));
});

var SvgExitFullscreen = function SvgExitFullscreen(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M8.872 16.127l-4.664 4.666a.708.708 0 1 1-1-1.002l4.663-4.665H3.708a.708.708 0 0 1 0-1.417H9.58c.39 0 .707.317.707.709v5.874a.708.708 0 1 1-1.415 0v-4.165zm0-8.254V3.708a.708.708 0 1 1 1.415 0v5.874a.708.708 0 0 1-.707.709H3.708a.708.708 0 0 1 0-1.417H7.87L3.207 4.21a.708.708 0 0 1 1.001-1.002l4.664 4.666zm6.256 8.254v4.165a.708.708 0 1 1-1.415 0v-5.874c0-.392.316-.709.707-.709h5.872a.708.708 0 0 1 0 1.417H16.13l4.664 4.665a.708.708 0 0 1-1.001 1.002l-4.664-4.666zm0-8.254l4.664-4.666a.708.708 0 1 1 1 1.002L16.13 8.874h4.163a.708.708 0 0 1 0 1.417H14.42a.708.708 0 0 1-.707-.709V3.708a.708.708 0 1 1 1.415 0v4.165z",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 0.95
  }));
};

var ExitFullscreen = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgExitFullscreen
  }, props));
});

var SvgExitFullscreenSquare = function SvgExitFullscreenSquare(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M21 8.727a.818.818 0 0 1-.818.818h-4.91a.818.818 0 0 1-.818-.818V3.818a.818.818 0 0 1 1.637 0V7.91h4.09c.453 0 .819.366.819.818zm-11.455 0a.818.818 0 0 1-.818.818H3.818a.818.818 0 1 1 0-1.636H7.91V3.82a.818.818 0 1 1 1.636 0v4.908zM8.727 21a.818.818 0 0 1-.818-.818V16.09H3.82a.818.818 0 1 1 0-1.637h4.908c.452 0 .818.367.818.819v4.909a.818.818 0 0 1-.818.818zm6.546 0a.818.818 0 0 1-.819-.818v-4.91c0-.451.367-.818.819-.818h4.909a.818.818 0 0 1 0 1.637H16.09v4.09a.818.818 0 0 1-.818.819z",
    fill: "currentColor"
  }));
};

var ExitFullscreenSquare = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgExitFullscreenSquare
  }, props));
});

var SvgFilter = function SvgFilter(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12.75 12.354a2.751 2.751 0 0 1 0 5.292v1.869a.75.75 0 0 1-1.5 0v-1.869a2.751 2.751 0 0 1 0-5.292V4.44a.75.75 0 1 1 1.5 0v7.914zm6-6a2.751 2.751 0 0 1 0 5.292v7.869a.75.75 0 0 1-1.5 0v-7.869a2.751 2.751 0 0 1 0-5.292V4.44a.75.75 0 1 1 1.5 0v1.914zm-12 0a2.751 2.751 0 0 1 0 5.292v7.869a.75.75 0 0 1-1.5 0v-7.869a2.751 2.751 0 0 1 0-5.292V4.44a.75.75 0 0 1 1.5 0v1.914zM6 10.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm12 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm-6 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    id: "filter_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "filter_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#filter_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#filter_svg__a"
  }), React.createElement("g", {
    mask: "url(#filter_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Filter = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFilter
  }, props));
});

var SvgFitScreen = function SvgFitScreen(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.139 5.922L8.53 8.53a.75.75 0 1 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12.639 5.7v12.39l2.83-2.83a.75.75 0 1 1 1.061 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l2.609 2.608V5.922z",
    id: "fit-screen_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "fit-screen_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#fit-screen_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#fit-screen_svg__a"
  }), React.createElement("g", {
    mask: "url(#fit-screen_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var FitScreen = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFitScreen
  }, props));
});

var SvgFitWidth = function SvgFitWidth(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.139 5.922L8.53 8.53a.75.75 0 1 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12.639 5.7v12.39l2.83-2.83a.75.75 0 1 1 1.061 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l2.609 2.608V5.922z",
    id: "fit-width_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(90 12 11.895)",
    xlinkHref: "#fit-width_svg__a"
  })));
};

var FitWidth = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFitWidth
  }, props));
});

var SvgFolderDefault = function SvgFolderDefault(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M4.386 18.357h15.441V9.192H12.41a.75.75 0 0 1-.233-.037c-.246-.056-.47-.2-.626-.416L10.173 6.8a.75.75 0 0 1-.045-.057L8.84 4.924H4.386v13.433zM19.827 7.692v-.809h-7.754l.574.809h7.18zm1.476.56c.016.061.024.125.024.19v10.665a.75.75 0 0 1-.75.75H3.637a.75.75 0 0 1-.75-.75V4.174a.75.75 0 0 1 .75-.75h5.59a.75.75 0 0 1 .612.316l1.168 1.647a.759.759 0 0 1 .074-.004h9.496a.75.75 0 0 1 .75.75v1.93a.751.751 0 0 1-.024.19z",
    id: "folder-default_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "folder-default_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#folder-default_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#folder-default_svg__a"
  }), React.createElement("g", {
    mask: "url(#folder-default_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var FolderDefault = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFolderDefault
  }, props));
});

var SvgFolderDynamic = function SvgFolderDynamic(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M21.327 13.386a4.474 4.474 0 0 0-1.5-.374v-3.82H12.41a.75.75 0 0 1-.233-.037c-.246-.056-.47-.2-.626-.416L10.173 6.8a.75.75 0 0 1-.045-.057L8.84 4.924H4.386v13.433h10.696c.104.541.305 1.047.584 1.5H3.636a.75.75 0 0 1-.75-.75V4.174a.75.75 0 0 1 .75-.75h5.592a.75.75 0 0 1 .611.316l1.168 1.647a.759.759 0 0 1 .074-.004h9.496a.75.75 0 0 1 .75.75v1.93a.751.751 0 0 1-.024.19c.016.06.024.124.024.189v4.944zm-1.5-5.694v-.809h-7.754l.574.809h7.18zM18.12 20.416l-.976-.704.944-1.664-1.728-.784.368-1.152 1.856.384.208-1.888h1.232l.208 1.904 1.84-.4.384 1.152-1.728.784.944 1.664-.976.704-1.28-1.424-1.296 1.424z",
    id: "folder-dynamic_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "folder-dynamic_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#folder-dynamic_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#folder-dynamic_svg__a"
  }), React.createElement("g", {
    mask: "url(#folder-dynamic_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var FolderDynamic = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFolderDynamic
  }, props));
});

var SvgForward15Secs = function SvgForward15Secs(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 28 26",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.006 9.154h-4.395a.77.77 0 0 1 0-1.539h2.912a8.462 8.462 0 1 0-6.528 13.846.77.77 0 0 1 0 1.539c-5.522 0-10-4.477-10-10s4.478-10 10-10a9.976 9.976 0 0 1 7.462 3.342V3.77a.77.77 0 1 1 1.539 0v4.616a.77.77 0 0 1-.77.769h-.22zm-.547 10.66c1.524 0 2.541-.962 2.541-2.371 0-1.303-.893-2.229-2.155-2.229-.658 0-1.128.245-1.409.65h-.082l.147-1.708h3.098V13h-4.175l-.332 3.854h1.243c.23-.373.622-.599 1.137-.599.705 0 1.202.488 1.202 1.22 0 .723-.493 1.202-1.206 1.202-.631 0-1.119-.369-1.197-.921h-1.285c.042 1.188 1.027 2.058 2.473 2.058zm-5.746-.17h1.39V13h-1.386L14 14.183v1.294l1.63-1.123h.083v5.29z",
    fill: "currentColor"
  }));
};

var Forward15Secs = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgForward15Secs
  }, props));
});

var SvgFullScreenOutlined = function SvgFullScreenOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.454 3.818c0-.452.367-.818.819-.818h4.909c.452 0 .818.366.818.818v4.91a.818.818 0 1 1-1.636 0V4.635h-4.091a.818.818 0 0 1-.819-.818zM3 3.818C3 3.366 3.366 3 3.818 3h4.91a.818.818 0 1 1 0 1.636H4.635v4.091a.818.818 0 1 1-1.636 0V3.818zm.818 10.636c.452 0 .818.367.818.819v4.09h4.091a.818.818 0 1 1 0 1.637H3.818A.818.818 0 0 1 3 20.182v-4.91c0-.451.366-.818.818-.818zm16.364 0c.452 0 .818.367.818.819v4.909a.818.818 0 0 1-.818.818h-4.91a.818.818 0 0 1 0-1.636h4.092v-4.091c0-.452.366-.819.818-.819z",
    fill: "#fff"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.954 3.818c0-.728.59-1.318 1.319-1.318h4.909c.728 0 1.318.59 1.318 1.318v4.91a1.318 1.318 0 0 1-2.636 0V5.135h-3.591c-.728 0-1.319-.59-1.319-1.318zm-11.454 0c0-.728.59-1.318 1.318-1.318h4.91a1.318 1.318 0 1 1 0 2.636H5.135v3.591a1.318 1.318 0 1 1-2.636 0V3.818zm1.318 10.136c.728 0 1.318.59 1.318 1.319v3.59h3.591a1.318 1.318 0 0 1 0 2.637H3.818c-.728 0-1.318-.59-1.318-1.318v-4.91c0-.727.59-1.318 1.318-1.318zm16.364 0c.728 0 1.318.59 1.318 1.319v4.909c0 .728-.59 1.318-1.318 1.318h-4.91a1.318 1.318 0 0 1 0-2.636h3.592v-3.591c0-.728.59-1.319 1.318-1.319zM15.272 3a.818.818 0 0 0 0 1.636h4.092v4.091a.818.818 0 1 0 1.636 0V3.818A.818.818 0 0 0 20.182 3h-4.91zM3.819 3A.818.818 0 0 0 3 3.818v4.91a.818.818 0 1 0 1.636 0V4.635h4.091a.818.818 0 1 0 0-1.636H3.818zm.818 12.273a.818.818 0 0 0-1.636 0v4.909c0 .452.366.818.818.818h4.91a.818.818 0 1 0 0-1.636H4.635v-4.091zm16.364 0a.818.818 0 0 0-1.636 0v4.09h-4.091a.818.818 0 0 0 0 1.637h4.909a.818.818 0 0 0 .818-.818v-4.91z",
    fill: "#536872"
  }));
};

var FullScreenOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFullScreenOutlined
  }, props));
});

var SvgFullscreen = function SvgFullscreen(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M13.06 12l6.19 6.19v-4.412a.75.75 0 1 1 1.5 0V20a.75.75 0 0 1-.75.75h-6.222a.75.75 0 1 1 0-1.5h4.411L12 13.06l-6.19 6.19h4.412a.75.75 0 1 1 0 1.5H4a.75.75 0 0 1-.75-.75v-6.222a.75.75 0 1 1 1.5 0v4.411L10.94 12 4.75 5.81v4.412a.75.75 0 1 1-1.5 0V4A.75.75 0 0 1 4 3.25h6.222a.75.75 0 1 1 0 1.5H5.811L12 10.94l6.19-6.19h-4.412a.75.75 0 1 1 0-1.5H20a.75.75 0 0 1 .75.75v6.222a.75.75 0 1 1-1.5 0V5.811L13.06 12z",
    fill: "currentColor"
  }));
};

var Fullscreen = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFullscreen
  }, props));
});

var SvgFullscreenSquare = function SvgFullscreenSquare(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M14.454 3.818c0-.452.367-.818.819-.818h4.909c.452 0 .818.366.818.818v4.91a.818.818 0 1 1-1.636 0V4.635h-4.091a.818.818 0 0 1-.819-.818zM3 3.818C3 3.366 3.366 3 3.818 3h4.91a.818.818 0 1 1 0 1.636H4.635v4.091a.818.818 0 1 1-1.636 0V3.818zm.818 10.636c.452 0 .818.367.818.819v4.09h4.091a.818.818 0 1 1 0 1.637H3.818A.818.818 0 0 1 3 20.182v-4.91c0-.451.366-.818.818-.818zm16.364 0c.452 0 .818.367.818.819v4.909a.818.818 0 0 1-.818.818h-4.91a.818.818 0 0 1 0-1.636h4.092v-4.091c0-.452.366-.819.818-.819z",
    fill: "currentColor"
  }));
};

var FullscreenSquare = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgFullscreenSquare
  }, props));
});

var SvgGlobal = function SvgGlobal(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M8.27 11.25h2.98V9.686a13.775 13.775 0 0 1-2.583-.38 8.612 8.612 0 0 0-.398 1.944zm.015 1.5c.07.67.225 1.34.465 2.008.837-.215 1.67-.352 2.5-.41V12.75H8.285zm7.446-1.5a8.636 8.636 0 0 0-.417-2.004c-.85.229-1.704.371-2.564.428v1.576h2.981zm-.015 1.5H12.75v1.58c.846.04 1.687.161 2.523.366a8.54 8.54 0 0 0 .443-1.946zm4.5 0h-2.993a9.946 9.946 0 0 1-.516 2.38c.798.29 1.591.656 2.378 1.099a8.199 8.199 0 0 0 1.131-3.479zm0-1.5a8.2 8.2 0 0 0-1.19-3.575c-.758.44-1.522.808-2.29 1.105.274.824.44 1.648.5 2.47h2.98zm-16.432 1.5a8.2 8.2 0 0 0 1.154 3.518c.796-.425 1.59-.78 2.38-1.067a9.97 9.97 0 0 1-.54-2.451H3.784zm0-1.5h2.981c.057-.789.212-1.579.467-2.37a17.97 17.97 0 0 1-2.365-1.028 8.198 8.198 0 0 0-1.083 3.398zm7.466 7.564v-2.961a12.34 12.34 0 0 0-1.878.296c.476.888 1.102 1.776 1.878 2.665zm1.5 0c.793-.907 1.429-1.814 1.908-2.721a11.567 11.567 0 0 0-1.908-.26v2.982zm-1.5-13.898C10.402 5.919 9.733 6.913 9.243 7.9c.673.152 1.342.246 2.007.283V4.916zm1.5 0V8.17c.664-.05 1.324-.157 1.98-.322-.487-.971-1.147-1.948-1.98-2.933zm5.444 12.534a14.192 14.192 0 0 0-2.071-.935c-.598 1.2-1.432 2.393-2.502 3.576a8.242 8.242 0 0 0 4.573-2.641zm-12.354.038a8.24 8.24 0 0 0 4.54 2.603c-1.05-1.161-1.874-2.332-2.47-3.51-.685.244-1.375.546-2.07.907zM18.119 6.466a8.245 8.245 0 0 0-4.203-2.492c.957 1.137 1.709 2.277 2.255 3.416.652-.25 1.301-.558 1.948-.924zm-12.372.152c.684.345 1.363.635 2.038.867.55-1.17 1.316-2.342 2.3-3.511a8.248 8.248 0 0 0-4.338 2.644zM12 21.75c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75z",
    id: "global_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "global_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#global_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#global_svg__a"
  }), React.createElement("g", {
    mask: "url(#global_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Global = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgGlobal
  }, props));
});

var SvgHeartDefault = function SvgHeartDefault(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M21 9.306a5.27 5.27 0 0 1-1.553 3.747L12.82 19.66a1.166 1.166 0 0 1-1.648-.004l-6.615-6.618A5.262 5.262 0 0 1 3 9.298a5.25 5.25 0 0 1 1.548-3.749A5.258 5.258 0 0 1 8.286 4c1.398 0 2.722.545 3.72 1.528a5.263 5.263 0 0 1 3.708-1.518c1.414 0 2.742.55 3.741 1.55 1 1 1.55 2.333 1.545 3.746zm-2.53 2.766a3.885 3.885 0 0 0 1.145-2.768 3.86 3.86 0 0 0-1.139-2.765 3.867 3.867 0 0 0-2.762-1.143 3.88 3.88 0 0 0-2.765 1.147l-.454.454a.692.692 0 0 1-.98 0l-.46-.461a3.89 3.89 0 0 0-2.77-1.15 3.874 3.874 0 0 0-2.757 1.143 3.866 3.866 0 0 0-1.143 2.766c0 1.043.407 2.02 1.15 2.763l6.462 6.466 6.472-6.452z",
    id: "heart-default_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    opacity: 0.4,
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "heart-default_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#heart-default_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#heart-default_svg__a"
  }), React.createElement("g", {
    mask: "url(#heart-default_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var HeartDefault = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgHeartDefault
  }, props));
});

var SvgHeartSelected = function SvgHeartSelected(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M21 9.306a5.27 5.27 0 0 1-1.553 3.747L12.82 19.66a1.166 1.166 0 0 1-1.648-.004l-6.615-6.618A5.262 5.262 0 0 1 3 9.298a5.25 5.25 0 0 1 1.548-3.749A5.258 5.258 0 0 1 8.286 4c1.398 0 2.722.545 3.72 1.528a5.263 5.263 0 0 1 3.708-1.518c1.414 0 2.742.55 3.741 1.55 1 1 1.55 2.333 1.545 3.746z",
    id: "heart-selected_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    opacity: 0.4,
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "heart-selected_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#heart-selected_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#heart-selected_svg__a"
  }), React.createElement("g", {
    mask: "url(#heart-selected_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var HeartSelected = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgHeartSelected
  }, props));
});

var SvgHome = function SvgHome(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M15.447 20.25h2.914V9.742c0-.07.01-.139.028-.203L12 4.211 5.611 9.539a.75.75 0 0 1 .028.203V20.25h2.974v-6.831a.75.75 0 0 1 .75-.75h5.334a.75.75 0 0 1 .75.75v6.831zm-1.5 0v-6.081h-3.834v6.081h3.834zm-9.808-9.483l-.185.154a.75.75 0 1 1-.96-1.152l8.526-7.111a.75.75 0 0 1 .96 0l8.527 7.111a.75.75 0 0 1-.961 1.152l-.185-.154V21a.75.75 0 0 1-.75.75H4.89a.75.75 0 0 1-.75-.75V10.767z",
    id: "home_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "home_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#home_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#home_svg__a"
  }), React.createElement("g", {
    mask: "url(#home_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Home = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgHome
  }, props));
});

var SvgHot = function SvgHot(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M18.885 14.057A6.95 6.95 0 0 1 11.943 21a6.95 6.95 0 0 1-6.935-7.315c.048-1.68.446-2.975 1.095-3.921.424-.62.878-.992 1.234-1.163a1.116 1.116 0 0 1 1.594.838c.042.281.126.585.246.86.057-.717.155-1.37.314-2 .486-1.921 1.857-3.902 3.513-5.087a1.115 1.115 0 1 1 1.767.903c0 .895.284 1.625.942 2.59.164.24.306.436.646.893 1.659 2.233 2.319 3.539 2.489 5.753l.012.16c.019.258.025.38.025.546zm-11.51-3.421c-.475.694-.785 1.7-.826 3.118a5.407 5.407 0 0 0 5.394 5.703c2.976 0 5.4-2.423 5.4-5.4 0-.117-.006-.212-.022-.43l-.012-.16c-.141-1.846-.69-2.931-2.189-4.95-.352-.473-.502-.68-.682-.944-.626-.917-1.003-1.724-1.145-2.613-1.091.993-1.971 2.393-2.306 3.717-.236.933-.321 1.98-.33 3.293a.771.771 0 0 1-.932.75c-.897-.192-1.516-.844-1.924-1.747a5.41 5.41 0 0 1-.228-.598c-.064.075-.13.162-.198.26zm3.586 4.23c.136-.566.448-1.154.857-1.634a.771.771 0 0 1 1.328.284c.09.308.226.542.597 1.07.676.96.945 1.528 1.017 2.527.008.105.011.16.011.239 0 1.623-1.257 2.962-2.828 2.962-1.572 0-2.829-1.339-2.829-2.962 0-.078 0-.121.003-.155.015-.555.116-1.017.287-1.39a.771.771 0 0 1 1.421.04c.02-.364.061-.668.136-.98zm.982 3.905c.697 0 1.285-.627 1.285-1.42 0-.028-.001-.055-.006-.126-.048-.653-.213-1.002-.74-1.752a26.014 26.014 0 0 1-.056-.078c-.056.312-.075.673-.075 1.211 0 .616-.499 1.115-1.114 1.115-.197 0-.381-.027-.553-.078.123.65.65 1.128 1.259 1.128z",
    id: "Hot_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "Hot_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#Hot_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#Hot_svg__a"
  }), React.createElement("g", {
    mask: "url(#Hot_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Hot = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgHot
  }, props));
});

var SvgImage = function SvgImage(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M18.629 15.91V13.84a.684.684 0 0 1-.222-.138l-2.91-2.7-2.268 2.495.567.53a.686.686 0 0 1-.936 1.002l-2.386-2.23-3.536 3.11h11.69zm0 1.371H5.37v1.348H18.63V17.28zm0-5.243V5.371H5.37v10.09l4.664-4.101a.686.686 0 0 1 .921.014l1.27 1.188 2.722-2.994a.686.686 0 0 1 .973-.041l2.708 2.511zM4.686 4h14.628c.379 0 .686.307.686.686v14.628a.686.686 0 0 1-.686.686H4.686A.686.686 0 0 1 4 19.314V4.686C4 4.307 4.307 4 4.686 4zm3.2 7.771a2.057 2.057 0 1 1 0-4.114 2.057 2.057 0 0 1 0 4.114zm0-1.371a.686.686 0 1 0 0-1.371.686.686 0 0 0 0 1.371z",
    id: "image_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "image_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#image_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#image_svg__a"
  }), React.createElement("g", {
    mask: "url(#image_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Image = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgImage
  }, props));
});

var SvgInfo = function SvgInfo(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 1.385a7.616 7.616 0 1 0 0 15.231 7.616 7.616 0 0 0 0-15.231zm.6 8.561a.692.692 0 1 1-1.385 0V8.308a.692.692 0 1 1 1.385 0v4.638zm0 2.391a.692.692 0 0 1-1.385 0v-.092a.692.692 0 1 1 1.385 0v.092z",
    id: "info_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(-180 12 12)",
    xlinkHref: "#info_svg__a"
  })));
};

var Info = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgInfo
  }, props));
});

var SvgInsights = function SvgInsights(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M16.368 10.628a.75.75 0 0 1 .75.75 8.434 8.434 0 1 1-8.434-8.434.75.75 0 0 1 .75.75v6.934h6.934zm-14.618.75a6.934 6.934 0 0 0 13.828.75H8.684a.75.75 0 0 1-.75-.75V4.484a6.935 6.935 0 0 0-6.184 6.894zm18-2.756a.75.75 0 0 1-.75.75h-7.684a.75.75 0 0 1-.75-.75V.938a.75.75 0 0 1 .75-.75 8.434 8.434 0 0 1 8.434 8.434zm-7.684-6.894v6.144h6.144a6.937 6.937 0 0 0-6.144-6.144z",
    id: "Insights_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("g", {
    transform: "translate(2 2)"
  }, React.createElement("mask", {
    id: "Insights_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#Insights_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#Insights_svg__a"
  }), React.createElement("g", {
    mask: "url(#Insights_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M-2-2h24v24H-2z"
  })))));
};

var Insights = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgInsights
  }, props));
});

var SvgInteractiveContent = function SvgInteractiveContent(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M5.566 4.435a.8.8 0 1 0-1.132 1.13l3 3a.8.8 0 1 0 1.132-1.13l-3-3zM12.8 5a.8.8 0 0 0-1.6 0v2a.8.8 0 1 0 1.6 0V5zM18.566 6.566a.8.8 0 1 0-1.132-1.131l-2 2a.8.8 0 1 0 1.132 1.13l2-2zM5 11.2a.8.8 0 0 0 0 1.6h2a.8.8 0 0 0 0-1.6H5zM8.566 16.566a.8.8 0 0 0-1.132-1.131l-2 2a.8.8 0 0 0 1.132 1.13l2-2zM11.394 10.08a1 1 0 0 0-1.313 1.314l3 7a1 1 0 0 0 1.814.053l.712-1.425 2.686 2.685a1 1 0 0 0 1.414-1.414l-2.686-2.686 1.426-.712a1 1 0 0 0-.053-1.814l-7-3z",
    fill: "currentColor"
  }));
};

var InteractiveContent = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgInteractiveContent
  }, props));
});

var SvgLine = function SvgLine(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M4.47 5.53a.75.75 0 0 1 1.06-1.06l14.143 14.142a.75.75 0 0 1-1.061 1.06L4.47 5.53z",
    fill: "currentColor"
  }));
};

var Line = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgLine
  }, props));
});

var SvgLink = function SvgLink(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M10.625 15.332a.752.752 0 0 1 0 1.503H7.57c-2.517 0-4.57-1.97-4.57-4.417S5.053 8 7.57 8h3.055a.752.752 0 1 1 0 1.504H7.57c-1.7 0-3.066 1.311-3.066 2.914 0 1.602 1.366 2.914 3.066 2.914h3.055zm2.75-5.828a.752.752 0 1 1 0-1.504h3.055C18.947 8 21 9.97 21 12.418c0 2.447-2.053 4.417-4.57 4.417h-3.055a.752.752 0 1 1 0-1.503h3.055c1.7 0 3.066-1.312 3.066-2.914 0-1.603-1.366-2.914-3.066-2.914h-3.055zM7.99 13.25a.752.752 0 0 1 0-1.503h8.02a.752.752 0 1 1 0 1.503H7.99z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Link = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgLink
  }, props));
});

var SvgLocation = function SvgLocation(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 20.25c-.483.111-.483.111-.721.55-.032.272-.032.272-.006.373.037.114.037.114.052.14a13.61 13.61 0 0 0-.17-.251c-.077-.114-.53-.77-.673-.98a76.58 76.58 0 0 1-2.12-3.243 45.75 45.75 0 0 1-1.217-2.094C5.93 12.512 5.25 10.718 5.25 9.4c0-3.938 3.01-7.15 6.75-7.15s6.75 3.212 6.75 7.15c0 1.318-.68 3.112-1.895 5.345a45.75 45.75 0 0 1-1.217 2.094 76.58 76.58 0 0 1-2.12 3.243l-.674.98c-.08.117-.132.196-.162.244.008-.019.008-.019.045-.133.026-.1.026-.1-.006-.373-.238-.439-.238-.439-.721-.55zm.28-1.016a75.158 75.158 0 0 0 2.08-3.18c.433-.705.827-1.38 1.178-2.026 1.1-2.022 1.712-3.637 1.712-4.628 0-3.13-2.362-5.65-5.25-5.65S6.75 6.27 6.75 9.4c0 .99.613 2.606 1.712 4.628.351.645.745 1.321 1.178 2.026A75.159 75.159 0 0 0 12 19.642l.28-.408zm.115.983c.09.131.15.223.193.29.036.058.036.058.076.132.025.048.025.048.066.176.028.106.028.106-.005.382-.24.441-.24.441-.725.553-.485-.112-.485-.112-.725-.553-.033-.276-.033-.276-.005-.382.041-.128.041-.128.066-.176.04-.074.04-.074.076-.132.042-.067.103-.159.193-.29l.395-.575.395.575zM12 11.75a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5zm0-1.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    id: "location_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "location_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#location_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#location_svg__a"
  }), React.createElement("g", {
    mask: "url(#location_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Location = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgLocation
  }, props));
});

var SvgLocked = function SvgLocked(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M5.75 10.75v7.107c0 1.313 1.131 2.393 2.544 2.393h7.412c1.413 0 2.544-1.08 2.544-2.393V10.75H5.75zm1.5-1.5V6.889C7.25 4.322 9.381 2.25 12 2.25s4.75 2.072 4.75 4.639V9.25H19a.75.75 0 0 1 .75.75v7.857c0 2.158-1.818 3.893-4.044 3.893H8.294c-2.226 0-4.044-1.735-4.044-3.893V10A.75.75 0 0 1 5 9.25h2.25zm1.5 0h6.5V6.889C15.25 5.16 13.8 3.75 12 3.75S8.75 5.16 8.75 6.889V9.25zm3.572 7.603a.284.284 0 0 0-.27-.228.75.75 0 0 1 .001 1.5c-.56 0-1.058-.375-1.176-.873l-.58-1.864c-.266-1.106.608-2.138 1.756-2.138 1.148 0 2.021 1.032 1.742 2.186l-.553 1.768c-.132.546-.629.92-1.189.921a.75.75 0 1 1 0-1.5c-.12 0-.236.087-.256.18l.256-.818.269.866zm.028-1.816c.032-.137-.095-.287-.297-.287-.203 0-.33.15-.31.24l.31.997.297-.95z",
    id: "locked_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "locked_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#locked_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#locked_svg__a"
  }), React.createElement("g", {
    mask: "url(#locked_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Locked = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgLocked
  }, props));
});

var SvgMeetingSpace = function SvgMeetingSpace(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.373 7.422a1.627 1.627 0 0 1-.386-1.053c0-.916.758-1.653 1.685-1.653.928 0 1.685.737 1.685 1.653 0 .399-.144.764-.382 1.049.994.472 1.682 1.47 1.682 2.626a.5.5 0 0 1-.5.5h-4.97a.5.5 0 0 1-.5-.5c0-1.142.692-2.145 1.686-2.622zm-7.857 8.323a3.49 3.49 0 0 1-1.032-2.486c0-1.913 1.525-3.47 3.415-3.47 1.89 0 3.415 1.557 3.415 3.47a3.49 3.49 0 0 1-1.035 2.488c2.293.937 3.908 3.176 3.908 5.791a.75.75 0 0 1-.75.75H2.327a.75.75 0 0 1-.75-.75c0-2.59 1.638-4.852 3.939-5.793zm2.906-7.783a.75.75 0 0 1-1.5 0v-4a2.25 2.25 0 0 1 2.25-2.25h11a2.25 2.25 0 0 1 2.25 2.25v8a2.25 2.25 0 0 1-2.25 2.25h-6.891a.75.75 0 1 1 0-1.5h6.891a.75.75 0 0 0 .75-.75v-8a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75v4zM7.9 15.229c1.054 0 1.915-.878 1.915-1.97s-.86-1.97-1.915-1.97c-1.054 0-1.915.878-1.915 1.97s.86 1.97 1.915 1.97zm6.773-8.207c.381 0 .685-.295.685-.653 0-.358-.304-.653-.685-.653-.381 0-.685.295-.685.653 0 .358.304.653.685.653zm-6.79 9.757c-2.371 0-4.372 1.767-4.743 4.01h9.489c-.364-2.272-2.349-4.01-4.746-4.01zm6.79-8.653c-.908 0-1.682.612-1.914 1.418h3.83c-.227-.815-.997-1.418-1.916-1.418z",
    id: "meeting-space_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "meeting-space_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#meeting-space_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#meeting-space_svg__a"
  }), React.createElement("g", {
    mask: "url(#meeting-space_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var MeetingSpace = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgMeetingSpace
  }, props));
});

var SvgMenu = function SvgMenu(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M4 5.639a.75.75 0 0 1 0-1.5h16a.75.75 0 1 1 0 1.5H4zm0 7.111a.75.75 0 1 1 0-1.5h16a.75.75 0 1 1 0 1.5H4zm0 7.111a.75.75 0 1 1 0-1.5h16a.75.75 0 1 1 0 1.5H4z",
    id: "menu_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "menu_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#menu_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#menu_svg__a"
  }), React.createElement("g", {
    mask: "url(#menu_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Menu = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgMenu
  }, props));
});

var SvgMore = function SvgMore(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M10 6.615C10 5.723 10.717 5 11.615 5c.893 0 1.616.717 1.616 1.615 0 .893-.717 1.616-1.616 1.616A1.611 1.611 0 0 1 10 6.615zM10 12c0-.892.717-1.615 1.615-1.615.893 0 1.616.717 1.616 1.615 0 .892-.717 1.615-1.616 1.615A1.611 1.611 0 0 1 10 12zm0 5.385c0-.893.717-1.616 1.615-1.616.893 0 1.616.717 1.616 1.616 0 .892-.717 1.615-1.616 1.615A1.611 1.611 0 0 1 10 17.385z",
    id: "more_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    transform: "rotate(90 11.615 12)",
    xlinkHref: "#more_svg__a"
  })));
};

var More = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgMore
  }, props));
});

var SvgMove = function SvgMove(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M18.695 10.252h-4.846a.75.75 0 0 1-.75-.75V4.485H6.434v6.717a.75.75 0 0 1-1.5 0V3.735a.75.75 0 0 1 .75-.75h8.436a.75.75 0 0 1 .512.203l5.325 4.98a.75.75 0 0 1 .238.547v11.786a.75.75 0 0 1-.75.75H5.685a.75.75 0 0 1-.75-.75v-3.19a.75.75 0 1 1 1.5 0v2.44h12.26v-9.5zm-.31-1.5L14.6 5.21v3.54h3.787zm-6.798 4.498l-2.059-1.667a.75.75 0 1 1 .944-1.166l3.805 3.081a.75.75 0 0 1 .016 1.153l-3.805 3.259a.75.75 0 0 1-.976-1.14l2.359-2.02H4a.75.75 0 1 1 0-1.5h7.587z",
    id: "move_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "move_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#move_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#move_svg__a"
  }), React.createElement("g", {
    mask: "url(#move_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Move = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgMove
  }, props));
});

var SvgMute = function SvgMute(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M2 8.66c0-.943.804-1.708 1.794-1.708h2.438c.357-.304 1.163-.978 2.36-1.974l.011-.01 1.752-1.458.797-.661.088-.061a1.994 1.994 0 0 1 1.015-.288l.087.003.034.002c.69.063 1.225.574 1.382 1.204l.017.137v16.308l-.017.14a1.595 1.595 0 0 1-1.416 1.202l-.112.004c-.328 0-.66-.098-1.07-.344l-.796-.639L8.61 19.11l-.015-.013a289.332 289.332 0 0 1-2.36-1.909H3.795c-.99 0-1.794-.764-1.794-1.707V8.66zm10.526-4.73c-.05-.132-.156-.226-.259-.24l-.037-.002a.664.664 0 0 0-.302.093l-.751.625-1.751 1.457-.012.01a244.802 244.802 0 0 0-2.5 2.095l-.183.173H3.794c-.3 0-.545.233-.545.519v6.82c0 .288.244.52.545.52h2.937l.183.173c.07.066 1.053.863 2.488 2.017l.015.012 1.752 1.406.577.463c.125.1.163.13.162.132l-.02-.009c.146.085.256.117.317.118l.053-.001c.105-.01.215-.105.268-.242V3.93z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M10.364 20.517L8.61 19.11l-.015-.013a289.332 289.332 0 0 1-2.36-1.909H3.795c-.99 0-1.794-.764-1.794-1.707V8.66c0-.943.804-1.708 1.794-1.708h2.438c.357-.304 1.163-.978 2.36-1.974l.011-.01 1.752-1.458.797-.661.088-.061a1.994 1.994 0 0 1 1.015-.288l.087.003.034.002c.69.063 1.225.574 1.382 1.204l.017.137v16.308l-.017.14a1.595 1.595 0 0 1-1.416 1.202l-.112.004c-.328 0-.66-.098-1.07-.344l-.796-.639zM8.47 19.253l.015.013 1.753 1.407.807.647.011.007c.432.26.8.373 1.173.373l.119-.004h.01a1.795 1.795 0 0 0 1.593-1.353l.003-.012.02-.164V3.834l-.02-.162-.003-.012c-.176-.705-.776-1.283-1.558-1.354l-.04-.002-.09-.004h-.008c-.391 0-.757.108-1.116.314l-.007.004-.102.071-.803.668c-.598.496-1.195.993-1.753 1.458l-.012.01A427.756 427.756 0 0 0 6.16 6.752H3.794c-1.092 0-1.994.846-1.994 1.908v6.82c0 1.064.902 1.908 1.994 1.908h2.37c.383.316 1.164.947 2.307 1.865zm3.436.952a2.007 2.007 0 0 1-.018-.01l.019.008-.016-.014-.002-.001a10.723 10.723 0 0 0-.144-.117l-.578-.463-1.75-1.406-.016-.013a196.104 196.104 0 0 1-2.488-2.016L6.73 16H3.794a.532.532 0 0 1-.545-.52V8.66c0-.286.244-.519.545-.519h2.937l.183-.173c.075-.07 1.049-.887 2.5-2.095l.012-.01.128.153-.012.01a256.392 256.392 0 0 0-2.49 2.087l-.241.228H3.794c-.2 0-.345.152-.345.319v6.82c0 .168.145.32.345.32h3.017l.24.227.004.004.013.01.042.037.147.121.515.42 1.755 1.415.016.012 1.75 1.406m0 0l.578.463.13.104.03.026a.842.842 0 0 0 .16.064.169.169 0 0 0 .015.003l.036-.001a.099.099 0 0 0 .037-.023.224.224 0 0 0 .047-.062V3.973a.224.224 0 0 0-.045-.06.108.108 0 0 0-.037-.024h-.017a.465.465 0 0 0-.188.06l-.734.61-1.751 1.457-.128-.153 1.75-1.457.752-.625a.664.664 0 0 1 .302-.093l.037.002c.103.014.209.108.26.24v16.14c-.054.136-.164.231-.269.24l-.053.002a.393.393 0 0 1-.116-.024 1.062 1.062 0 0 1-.176-.08l-.006-.003m.074-.176l.004-.01h.001l-.005.01zM17.63 12l-1.41-1.412a.75.75 0 0 1 1.06-1.06l1.41 1.41 1.412-1.41a.75.75 0 1 1 1.06 1.06L19.752 12l1.41 1.41a.75.75 0 1 1-1.06 1.061l-1.411-1.41-1.41 1.41a.75.75 0 1 1-1.061-1.06L17.63 12z",
    fill: "currentColor"
  }));
};

var Mute = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgMute
  }, props));
});

var SvgMutedOutlined = function SvgMutedOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), React.createElement("g", {
    clipPath: "url(#muted-outlined_svg__clip0)"
  }, React.createElement("path", {
    d: "M19.07 12l1.41-1.41c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.41 1.41-1.41-1.41a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06L16.95 12l-1.41 1.41c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l1.41-1.41 1.41 1.41c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06L19.07 12z",
    fill: "#fff"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.07 12l1.41-1.41c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.41 1.41-1.41-1.41a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06L16.95 12l-1.41 1.41c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l1.41-1.41 1.41 1.41c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06L19.07 12zm-1.06 1.767l-1.056 1.057a1.255 1.255 0 0 1-1.768 0 1.255 1.255 0 0 1 0-1.768L16.244 12l-1.056-1.056a1.254 1.254 0 0 1 0-1.768 1.254 1.254 0 0 1 1.767 0l1.056 1.057 1.056-1.057a1.254 1.254 0 0 1 1.768 0 1.255 1.255 0 0 1 0 1.768L19.777 12l1.057 1.056a1.255 1.255 0 0 1 0 1.768 1.255 1.255 0 0 1-1.767 0l-1.057-1.057z",
    fill: "#536872"
  }), React.createElement("path", {
    d: "M11.53 2.305c-.328-.008-.844.056-1.22.37-1.622 1.359-3.273 2.683-4.87 4.07H3.07c-1.09 0-1.99.85-1.99 1.91v6.82c0 1.06.9 1.91 1.99 1.91h2.37c1.6 1.348 3.26 2.622 4.89 3.93l.01.01c.43.26.8.37 1.17.37.852 0 1.74-.613 1.74-1.52V3.825c0-.819-.866-1.52-1.72-1.52zm-.24 17.71c-1.752-1.366-3.565-2.71-5.2-4.22H3.07c-.2 0-.35-.15-.35-.32v-6.82c0-.17.15-.32.35-.32h3.02c1.64-1.572 3.478-2.934 5.22-4.39.097-.08.3-.062.3.14v15.767c0 .206-.194.261-.32.163z",
    fill: "#fff"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.285 15.295l.143.133c1.315 1.214 2.745 2.318 4.184 3.43l.497.384V4.76C9.481 6.093 7.811 7.377 6.29 8.835H3.22v6.46h3.065zm-.196-6.96H3.07c-.2 0-.35.15-.35.32v6.82c0 .17.15.32.35.32h3.02c1.333 1.23 2.784 2.351 4.224 3.464l.976.756c.126.098.32.043.32-.163V4.086c0-.203-.203-.222-.3-.14-1.744 1.456-3.576 2.814-5.22 4.39z",
    fill: "#536872"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.536 1.805c-.379-.008-1.038.06-1.548.487C8.425 3.6 6.81 4.899 5.253 6.245H3.069c-1.344 0-2.49 1.053-2.49 2.41v6.82c0 1.358 1.146 2.41 2.49 2.41h2.188a130.413 130.413 0 0 0 4.823 3.868c.49.296.948.442 1.43.442 1.104 0 2.242-.844 2.242-2.02 0-6.432.006-10.01.006-16.443 0-1.095-1.207-1.924-2.222-1.927zm-1.227.87c.376-.314.899-.378 1.227-.37.972 0 1.713.875 1.713 1.427v16.443c0 .907-.888 1.52-1.74 1.52-.359 0-.943-.19-1.18-.38-1.63-1.308-3.29-2.582-4.89-3.93H3.07c-1.09 0-1.99-.85-1.99-1.91v-6.82c0-1.06.9-1.91 1.99-1.91h2.37c1.597-1.387 3.248-2.711 4.87-4.07z",
    fill: "#536872"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "muted-outlined_svg__clip0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M.54 0h24v24h-24z"
  }))));
};

var MutedOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgMutedOutlined
  }, props));
});

var SvgNew = function SvgNew(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.115 6.294H9.724v7.754h3.391V6.294zm0-1.385V2.971H9.724v1.938h3.391zm-.044 10.523H9.768l1.651 2.315 1.652-2.315zm3.043-10.167a.771.771 0 1 1 1.09-1.09l6.688 6.687a.771.771 0 0 1 0 1.091L12.255 23.59a.771.771 0 0 1-1.09 0L-.473 11.953a.771.771 0 0 1 0-1.091l5.115-5.116a.771.771 0 0 1 1.091 1.091l-4.57 4.57L11.71 21.953l10.546-10.546-6.142-6.142zM9.072 1.586h4.695c.36 0 .652.31.652.692v13.325a.72.72 0 0 1-.132.418l-2.348 3.29a.63.63 0 0 1-1.04 0l-2.347-3.29a.72.72 0 0 1-.133-.418V2.278c0-.382.292-.692.653-.692z",
    id: "New_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(45 11.71 12.7)",
    xlinkHref: "#New_svg__a"
  })));
};

var New = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgNew
  }, props));
});

var SvgNewsCenter = function SvgNewsCenter(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M9.069 10.371V8.308H7.041v2.063H9.07zm.648 1.352H6.411c-.374 0-.721-.303-.721-.676V7.632c0-.373.347-.676.72-.676h3.307c.374 0 .676.303.676.676v3.415a.676.676 0 0 1-.676.676zm2.28-3.337a.676.676 0 1 1 0-1.351H13.8a.676.676 0 0 1 0 1.351h-1.802zm0 3.337a.676.676 0 1 1 0-1.352H13.8a.676.676 0 0 1 0 1.352h-1.802zm-5.614 3.59a.685.685 0 0 1-.693-.677c0-.373.31-.675.693-.675h7.4c.382 0 .693.302.693.675 0 .374-.31.676-.694.676H6.383zm9.458 2.571V4.352H4.338v13.532c0 1.025.714 1.562 1.74 1.562h10.157c-.213-.444-.394-.676-.394-1.562zm2.716 2.914H5.913C4.142 20.798 3 19.656 3 17.884V3.687C3 3.314 3.303 3 3.676 3h12.84c.374 0 .676.314.676.687v1.776h3.132c.373 0 .676.302.676.675v11.746c0 1.696-.864 2.914-2.443 2.914zm-1.365-2.914c0 1.004.663 1.562 1.339 1.562.676 0 1.126-.533 1.126-1.562V6.814h-2.465v11.07z",
    id: "news-center_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "news-center_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#news-center_svg__a"
  })), React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#news-center_svg__a"
  }), React.createElement("g", {
    mask: "url(#news-center_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var NewsCenter = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgNewsCenter
  }, props));
});

var SvgNext = function SvgNext(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M8.01 11.05H18a.75.75 0 1 1 0 1.5H7.61l2.92 2.92a.75.75 0 0 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-2.52 2.52z",
    id: "next_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("mask", {
    id: "next_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#next_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(-180 12 12)",
    xlinkHref: "#next_svg__a"
  }), React.createElement("g", {
    mask: "url(#next_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Next = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgNext
  }, props));
});

var SvgNotification = function SvgNotification(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M10.293 19.75H4a.75.75 0 0 1-.75-.75v-1.117c0-.173.06-.34.17-.475l1.608-1.97v-3.967c0-3.26 2-6.044 4.889-6.982v-.077c0-1.158.948-2.162 2.083-2.162 1.135 0 2.083 1.004 2.083 2.162v.077c2.889.938 4.89 3.722 4.89 6.982v3.968l1.608 1.97a.75.75 0 0 1 .169.474V19a.75.75 0 0 1-.75.75h-6.293a.749.749 0 0 1 .043.25 1.75 1.75 0 0 1-3.5 0c0-.088.015-.172.043-.25zm1.414 0a.749.749 0 0 1 .043.25c0 .137.113.25.25.25a.25.25 0 0 0 .25-.25c0-.088.015-.172.043-.25h-.586zm5.934-3.57a.75.75 0 0 1-.169-.474V11.47c0-2.784-1.798-5.105-4.307-5.682a.75.75 0 0 1-.582-.73v-.647c0-.348-.296-.662-.583-.662s-.583.314-.583.662v.647a.75.75 0 0 1-.582.73c-2.509.577-4.307 2.898-4.307 5.682v4.235a.75.75 0 0 1-.17.474L4.75 18.15v.1h14.5v-.1l-1.609-1.97z",
    id: "notification_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "notification_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#notification_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#notification_svg__a"
  }), React.createElement("g", {
    mask: "url(#notification_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Notification = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgNotification
  }, props));
});

var SvgOpen = function SvgOpen(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M17.694 5.15h-1.472a.75.75 0 0 1 0-1.5H19.6a.75.75 0 0 1 .75.75v3.378a.75.75 0 1 1-1.5 0v-1.65l-7.77 7.007a.75.75 0 0 1-1.005-1.114l7.62-6.871zm1.156 6.15a.75.75 0 1 1 1.5 0v5.767a3.283 3.283 0 0 1-3.283 3.283H6.933a3.283 3.283 0 0 1-3.283-3.283V6.933A3.283 3.283 0 0 1 6.933 3.65h5.747a.75.75 0 0 1 0 1.5H6.933c-.985 0-1.783.798-1.783 1.783v10.134c0 .985.798 1.783 1.783 1.783h10.134c.985 0 1.783-.798 1.783-1.783v-5.768z",
    id: "open_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("mask", {
    id: "open_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#open_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#open_svg__a"
  }), React.createElement("g", {
    mask: "url(#open_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M-39-33H61V67H-39z"
  }))));
};

var Open = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgOpen
  }, props));
});

var SvgOval = function SvgOval(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 12a8.75 8.75 0 1 0 17.5 0 8.75 8.75 0 0 0-17.5 0zm16 0a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0z",
    fill: "currentColor"
  }));
};

var Oval = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgOval
  }, props));
});

var SvgPageBack = function SvgPageBack(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0zm1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75zm-9.058 4.154a.692.692 0 0 1-1.384 0V7.846a.692.692 0 1 1 1.384 0v8.308zm1.31-2.982a.692.692 0 1 1 .98.98l-2.492 2.491a.692.692 0 0 1-.98 0l-2.492-2.492a.692.692 0 0 1 .98-.979L12 15.175l2.003-2.003z",
    id: "page-back_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(90 12 12)",
    xlinkHref: "#page-back_svg__a"
  })));
};

var PageBack = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPageBack
  }, props));
});

var SvgPageDown = function SvgPageDown(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0zm1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75zm-9.058 4.154a.692.692 0 0 1-1.384 0V7.846a.692.692 0 1 1 1.384 0v8.308zm1.31-2.982a.692.692 0 1 1 .98.98l-2.492 2.491a.692.692 0 0 1-.98 0l-2.492-2.492a.692.692 0 0 1 .98-.979L12 15.175l2.003-2.003z",
    id: "page-down_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "page-down_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#page-down_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 24 0)",
    xlinkHref: "#page-down_svg__a"
  }), React.createElement("g", {
    mask: "url(#page-down_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var PageDown = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPageDown
  }, props));
});

var SvgPageForward = function SvgPageForward(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0zm1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75zm-9.058 4.154a.692.692 0 0 1-1.384 0V7.846a.692.692 0 1 1 1.384 0v8.308zm1.31-2.982a.692.692 0 1 1 .98.98l-2.492 2.491a.692.692 0 0 1-.98 0l-2.492-2.492a.692.692 0 0 1 .98-.979L12 15.175l2.003-2.003z",
    id: "page-forward_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(-90 12 12)",
    xlinkHref: "#page-forward_svg__a"
  })));
};

var PageForward = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPageForward
  }, props));
});

var SvgPageUp = function SvgPageUp(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0zm1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75zm-9.058 4.154a.692.692 0 0 1-1.384 0V7.846a.692.692 0 1 1 1.384 0v8.308zm1.31-2.982a.692.692 0 1 1 .98.98l-2.492 2.491a.692.692 0 0 1-.98 0l-2.492-2.492a.692.692 0 0 1 .98-.979L12 15.175l2.003-2.003z",
    id: "page-up_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(-180 12 12)",
    xlinkHref: "#page-up_svg__a"
  })));
};

var PageUp = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPageUp
  }, props));
});

var SvgPause = function SvgPause(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 30 30"
  }, props), React.createElement("path", {
    d: "M5.543 2.16h4.915v25.68H5.543V2.16zm14 0h4.914v25.68h-4.915V2.16z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var Pause = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPause
  }, props));
});

var SvgPauseOutlined = function SvgPauseOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 18 26",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M6.583 2.5A1.75 1.75 0 0 0 4.833.75H2.5A1.75 1.75 0 0 0 .75 2.5v21c0 .966.784 1.75 1.75 1.75h2.333a1.75 1.75 0 0 0 1.75-1.75v-21zm10.667 0A1.75 1.75 0 0 0 15.5.75h-2.333a1.75 1.75 0 0 0-1.75 1.75v21c0 .966.783 1.75 1.75 1.75H15.5a1.75 1.75 0 0 0 1.75-1.75v-21z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 0.5
  }));
};

var PauseOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPauseOutlined
  }, props));
});

var SvgPhoneDefault = function SvgPhoneDefault(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.443 14.502l1.008-.514a2.1 2.1 0 0 1 2.822.917l1.248 2.45a2.1 2.1 0 0 1-.917 2.823l-1.064.542a4.776 4.776 0 0 1-2.175.527v-.75.75c-.289 0-.577-.026-.864-.079a4.783 4.783 0 0 1-3.43-2.55L5.777 10.19a4.785 4.785 0 0 1-.047-4.274 4.765 4.765 0 0 1 2.149-2.195l1.064-.542a2.098 2.098 0 0 1 2.82.914l1.25 2.453c.254.498.3 1.07.126 1.6a2.088 2.088 0 0 1-1.042 1.223l-1.008.513 2.354 4.62zm.922 5.995v-.75c.516 0 1.023-.123 1.494-.363l1.064-.542a.6.6 0 0 0 .262-.805l-1.249-2.451a.6.6 0 0 0-.805-.261l-1.374.7a1.089 1.089 0 0 1-1.464-.476l-2.727-5.353a1.09 1.09 0 0 1 .476-1.464l1.374-.7a.589.589 0 0 0 .297-.348.589.589 0 0 0-.036-.457l-1.25-2.453a.598.598 0 0 0-.803-.259l-1.064.542a3.267 3.267 0 0 0-1.48 1.511 3.285 3.285 0 0 0 .032 2.941l4.296 8.428a3.283 3.283 0 0 0 2.362 1.756c.198.036.397.054.595.054v.75z",
    id: "phone-default_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "phone-default_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#phone-default_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#phone-default_svg__a"
  }), React.createElement("g", {
    mask: "url(#phone-default_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var PhoneDefault = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPhoneDefault
  }, props));
});

var SvgPhoneSpeaking = function SvgPhoneSpeaking(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.443 14.502l1.008-.514a2.1 2.1 0 0 1 2.822.917l1.248 2.45a2.1 2.1 0 0 1-.917 2.823l-1.064.542a4.776 4.776 0 0 1-2.175.527v-.75.75c-.289 0-.577-.026-.864-.079a4.783 4.783 0 0 1-3.43-2.55L5.777 10.19a4.785 4.785 0 0 1-.047-4.274 4.765 4.765 0 0 1 2.149-2.195l1.064-.542a2.098 2.098 0 0 1 2.82.914l1.25 2.453c.254.498.3 1.07.126 1.6a2.088 2.088 0 0 1-1.042 1.223l-1.008.513 2.354 4.62zm.922 5.995v-.75c.516 0 1.023-.123 1.494-.363l1.064-.542a.6.6 0 0 0 .262-.805l-1.249-2.451a.6.6 0 0 0-.805-.261l-1.374.7a1.089 1.089 0 0 1-1.464-.476l-2.727-5.353a1.09 1.09 0 0 1 .476-1.464l1.374-.7a.589.589 0 0 0 .297-.348.589.589 0 0 0-.036-.457l-1.25-2.453a.598.598 0 0 0-.803-.259l-1.064.542a3.267 3.267 0 0 0-1.48 1.511 3.285 3.285 0 0 0 .032 2.941l4.296 8.428a3.283 3.283 0 0 0 2.362 1.756c.198.036.397.054.595.054v.75zm1.062-12.75a.75.75 0 1 1 .146-1.493c1.376.135 2.427 1.006 3.11 2.509.674 1.484.674 2.88-.033 4.11a.75.75 0 0 1-1.3-.747c.452-.787.452-1.676-.033-2.742-.476-1.048-1.092-1.56-1.89-1.638zm.848-3a.75.75 0 1 1 .112-1.495c2.403.181 4.144 1.384 5.127 3.548.956 2.102 1.019 4.123.17 6.008a.75.75 0 1 1-1.368-.616c.665-1.476.616-3.048-.168-4.772-.755-1.662-2.014-2.532-3.873-2.672z",
    id: "phone-speaking_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "phone-speaking_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#phone-speaking_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#phone-speaking_svg__a"
  }), React.createElement("g", {
    mask: "url(#phone-speaking_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var PhoneSpeaking = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPhoneSpeaking
  }, props));
});

var SvgPlay = function SvgPlay(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 30 30"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M6 .498L25 15 6 29.502z"
  }));
};

var Play = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPlay
  }, props));
});

var SvgPlayOutlined = function SvgPlayOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 22 26",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M20.52 14.495a1.75 1.75 0 0 0 0-2.99L3.535 1.18C2.368.472.875 1.311.875 2.677v20.646c0 1.365 1.493 2.205 2.659 1.496L20.52 14.496z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 0.5
  }));
};

var PlayOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPlayOutlined
  }, props));
});

var SvgPresentLiveContent = function SvgPresentLiveContent(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.889 4h6.61a6.47 6.47 0 0 0-.494 2.253H5.333v7.208h13.334v-.565A6.45 6.45 0 0 0 20 12.502v1.41a.895.895 0 0 1-.889.9h-6.444v1.992l3.187 2.36a.68.68 0 0 1 .298.907.662.662 0 0 1-.895.302L12 17.821l-3.257 2.552a.662.662 0 0 1-.895-.302.68.68 0 0 1 .298-.907l3.187-2.36v-1.991H4.89A.895.895 0 0 1 4 13.912v-9.01C4 4.402 4.398 4 4.889 4z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M14.275 2.716a.395.395 0 1 0-.559.559l1.481 1.48a.395.395 0 1 0 .559-.558l-1.481-1.48zM17.846 2.996a.395.395 0 1 0-.79 0v.987a.395.395 0 1 0 .79 0v-.987zM20.692 3.768a.395.395 0 0 0-.558-.558l-.987.987a.395.395 0 0 0 .558.559l.988-.988zM13.995 6.056a.395.395 0 0 0 0 .79h.988a.395.395 0 0 0 0-.79h-.988zM15.756 8.705a.395.395 0 0 0-.559-.558l-.987.987a.395.395 0 0 0 .558.558l.988-.987zM17.152 5.504a.494.494 0 0 0-.648.648l1.48 3.456a.494.494 0 0 0 .896.026l.352-.704 1.326 1.326a.494.494 0 0 0 .698-.698L19.93 8.232l.704-.352a.493.493 0 0 0-.026-.895l-3.456-1.481z",
    fill: "currentColor"
  }));
};

var PresentLiveContent = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPresentLiveContent
  }, props));
});

var SvgPresenter = function SvgPresenter(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.25 17.11V14.9H4a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-7.25v2.21l3.585 2.62a.75.75 0 1 1-.67 1.34L12 18.24 8.335 21.07a.75.75 0 0 1-.67-1.342l3.585-2.62zM4.5 5.4v8h15v-8h-15z",
    id: "presenter_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "presenter_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#presenter_svg__a"
  })), React.createElement("use", {
    fill: "#2B3C41",
    fillRule: "nonzero",
    xlinkHref: "#presenter_svg__a"
  }), React.createElement("g", {
    mask: "url(#presenter_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Presenter = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPresenter
  }, props));
});

var SvgPreview = function SvgPreview(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M12 16.667c3.17 0 6.029-1.822 7.484-4.667C18.03 9.155 15.17 7.333 12 7.333c-3.17 0-6.029 1.822-7.484 4.667C5.97 14.845 8.83 16.667 12 16.667zm-8.87-4.943C4.756 8.257 8.176 6 12 6c3.824 0 7.244 2.257 8.87 5.724L21 12l-.13.276C19.244 15.743 15.824 18 12 18c-3.824 0-7.244-2.257-8.87-5.724L3 12l.13-.276zM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Preview = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPreview
  }, props));
});

var SvgPrint = function SvgPrint(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M7.193 8.97H4.796c-.497 0-.9.398-.9.889v7.11h2.528v-3.058c0-.252.2-.456.446-.456h10.26c.246 0 .446.204.446.456v6.845c0 .252-.2.456-.446.456H6.87a.451.451 0 0 1-.446-.456v-2.453H2.995a.447.447 0 0 1-.45-.444v-8c0-1.228 1.008-2.223 2.251-2.223H6.91V3.913c0-.621.495-1.125 1.107-1.125h7.968c.612 0 1.107.504 1.107 1.125v3.723h2.113c1.243 0 2.25.995 2.25 2.223v8a.447.447 0 0 1-.45.444h-3.391V16.97h2.491V9.859a.895.895 0 0 0-.9-.89h-2.397a.653.653 0 0 1-.76 0H7.953a.653.653 0 0 1-.76 0zm8.57-1.334V4.138H8.237v3.498h7.526zm-8 7.188v5.02h8.475v-5.02H7.762zm-1.339-2.34a.97.97 0 1 1 0-1.939.97.97 0 0 1 0 1.94z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Print = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgPrint
  }, props));
});

var SvgRecord = function SvgRecord(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-1.385a7.616 7.616 0 1 0 0-15.231 7.616 7.616 0 0 0 0 15.231zM12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10z",
    id: "record_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "record_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#record_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#record_svg__a"
  }), React.createElement("g", {
    mask: "url(#record_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Record = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgRecord
  }, props));
});

var SvgRectangle = function SvgRectangle(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM5.5 6a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V6z",
    fill: "currentColor"
  }));
};

var Rectangle = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgRectangle
  }, props));
});

var SvgRefresh = function SvgRefresh(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M7.798 6.253C6.488 7.44 5.644 8.949 5.337 9.87a.75.75 0 1 1-1.423-.474C4.299 8.24 5.282 6.509 6.79 5.142c1.523-1.38 3.64-2.44 6.249-2.067 1.973.282 3.773 1.512 5.193 2.819a21.856 21.856 0 0 1 2.265 2.457V5.064a.75.75 0 0 1 1.5 0v4.99a.75.75 0 0 1-.75.75h-4.991a.75.75 0 1 1 0-1.5h3.083a20.382 20.382 0 0 0-2.123-2.307c-1.34-1.233-2.863-2.219-4.39-2.437-2.043-.292-3.733.518-5.028 1.693zM16.199 17.79c1.309-1.187 2.153-2.696 2.46-3.617a.75.75 0 0 1 1.424.474c-.385 1.155-1.369 2.887-2.877 4.254-1.522 1.38-3.64 2.439-6.248 2.066-1.974-.282-3.773-1.51-5.193-2.818A21.85 21.85 0 0 1 3.5 15.692v3.287a.75.75 0 0 1-1.5 0v-4.991a.75.75 0 0 1 .75-.75h4.99a.75.75 0 0 1 0 1.5H4.659a20.386 20.386 0 0 0 2.123 2.307c1.339 1.233 2.863 2.22 4.389 2.437 2.044.292 3.733-.518 5.029-1.692z",
    fill: "#536872"
  }));
};

var Refresh = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgRefresh
  }, props));
});

var SvgReplay = function SvgReplay(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 30 30"
  }, props), React.createElement("path", {
    d: "M9.25 9.027l3.164 3.163H3.82V3.597l3.197 3.198A11.463 11.463 0 0 1 15.076 3.5c6.351 0 11.5 5.149 11.5 11.5s-5.149 11.5-11.5 11.5c-5.554 0-10.188-3.937-11.265-9.172h3.25a8.343 8.343 0 1 0 2.19-8.3z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Replay = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgReplay
  }, props));
});

var SvgReplayOutlined = function SvgReplayOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 25 26",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M4.344 2.333a1.583 1.583 0 0 0-3.167 0v5.334c0 .874.709 1.583 1.583 1.583H8a1.583 1.583 0 1 0 0-3.167H6.112A9.046 9.046 0 0 1 12 3.917 9.083 9.083 0 1 1 4.13 17.54a1.583 1.583 0 0 0-2.162-.578l.125.216-.125-.216a1.583 1.583 0 0 0-.578 2.163A12.246 12.246 0 0 0 12 25.25c6.765 0 12.25-5.485 12.25-12.25S18.765.75 12 .75a12.2 12.2 0 0 0-7.656 2.687V2.333z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }));
};

var ReplayOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgReplayOutlined
  }, props));
});

var SvgRewind15Secs = function SvgRewind15Secs(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 28 26",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.994 9.154h4.395a.77.77 0 0 0 0-1.539H7.477a8.461 8.461 0 1 1 6.528 13.846.77.77 0 0 0 0 1.539c5.522 0 10-4.477 10-10s-4.478-10-10-10a9.976 9.976 0 0 0-7.462 3.342V3.77a.77.77 0 0 0-1.539 0v4.616c0 .424.345.769.77.769h.22zm-.281 10.49h1.39V13H5.717L4 14.183v1.294l1.63-1.123h.083v5.29zm5.746.17c1.524 0 2.541-.962 2.541-2.371 0-1.303-.893-2.229-2.155-2.229-.658 0-1.128.245-1.409.65h-.082l.147-1.708h3.098V13H9.424l-.332 3.854h1.243c.23-.373.622-.599 1.137-.599.705 0 1.202.488 1.202 1.22 0 .723-.493 1.202-1.206 1.202-.631 0-1.119-.369-1.197-.921H8.986c.042 1.188 1.027 2.058 2.473 2.058z",
    fill: "currentColor"
  }));
};

var Rewind15Secs = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgRewind15Secs
  }, props));
});

var SvgRoundedPause = function SvgRoundedPause(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 15 21",
    fill: "none"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2a2 2 0 0 1 2-2h.915a2 2 0 0 1 2 2v16.68a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10 0a2 2 0 0 1 2-2h.914a2 2 0 0 1 2 2v16.68a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V2z",
    fill: "currentColor"
  }));
};

var RoundedPause = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgRoundedPause
  }, props));
});

var SvgRoundedPlay = function SvgRoundedPlay(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 17 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M0 2.912C0 1.28 1.848.335 3.171 1.29l12.584 9.089a2 2 0 0 1 0 3.242L3.171 22.71C1.848 23.665 0 22.72 0 21.088V2.913z",
    fill: "currentColor"
  }));
};

var RoundedPlay = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgRoundedPlay
  }, props));
});

var SvgScreenshare = function SvgScreenshare(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.25 5.642L9.001 7.57a.75.75 0 0 1-.976-1.138l3.988-3.419 3.988 3.419a.75.75 0 1 1-.976 1.138L12.75 5.62V12a.75.75 0 1 1-1.5 0V5.642zm1.5 13.608H15a.75.75 0 1 1 0 1.5H9a.75.75 0 1 1 0-1.5h2.25V17.5H4a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h2V6H4.5v10h15V6H18V4.5h2a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-7.25v1.75z",
    id: "screenshare_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "screenshare_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#screenshare_svg__a"
  })), React.createElement("use", {
    fill: "#2B3C41",
    fillRule: "nonzero",
    xlinkHref: "#screenshare_svg__a"
  }), React.createElement("g", {
    mask: "url(#screenshare_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Screenshare = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgScreenshare
  }, props));
});

var SvgSearch = function SvgSearch(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M15.557 14.497l5.121 5.12a.75.75 0 0 1-1.06 1.061l-5.121-5.12a7.5 7.5 0 1 1 1.06-1.06zm-1.42-.653a6 6 0 1 0-.293.293.75.75 0 0 1 .293-.293z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Search = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgSearch
  }, props));
});

var SvgSearchFile = function SvgSearchFile(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M17.224 20h.026a.75.75 0 1 1 0 1.5H5.377a.75.75 0 0 1-.75-.75V3.376a.75.75 0 0 1 .75-.75h9.388a.75.75 0 0 1 .536.226l4.056 4.15a.75.75 0 0 1 .213.525v.767h-1.697l-.013.003h-3.33a.75.75 0 0 1-.75-.75v-3.42H6.127V20h11.097zm1.821-2.355l2.305 3.07a.75.75 0 1 1-1.2.9l-2.4-3.198a4.75 4.75 0 1 1 1.296-.772zM15.28 4.976v1.821h1.779l-1.78-1.82zM16 17.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5z",
    id: "search-file_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "search-file_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#search-file_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#search-file_svg__a"
  }), React.createElement("g", {
    mask: "url(#search-file_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M1-4h28v28H1z"
  }))));
};

var SearchFile = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgSearchFile
  }, props));
});

var SvgSearchFolder = function SvgSearchFolder(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M20.75 8.33a.75.75 0 1 1-1.5 0V7a.25.25 0 0 0-.25-.25h-8a.75.75 0 0 1-.53-.22L8.69 4.75H5a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25h5a.75.75 0 1 1 0 1.5H5A1.75 1.75 0 0 1 3.25 16V5c0-.966.784-1.75 1.75-1.75h4a.75.75 0 0 1 .53.22l1.78 1.78H19c.966 0 1.75.784 1.75 1.75v1.33zm-1.705 9.315l2.305 3.07a.75.75 0 1 1-1.2.9l-2.4-3.198a4.75 4.75 0 1 1 1.296-.772zM16 17.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5z",
    id: "search-folder_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "search-folder_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#search-folder_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#search-folder_svg__a"
  }), React.createElement("g", {
    mask: "url(#search-folder_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M-2-6h32v32H-2z"
  }))));
};

var SearchFolder = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgSearchFolder
  }, props));
});

var SvgSearchSelected = function SvgSearchSelected(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M16.02 13.965l4.648 4.648a1.411 1.411 0 1 1-1.995 1.995l-4.649-4.648a7.505 7.505 0 1 1 1.995-1.995zm-6.21.57a4.785 4.785 0 1 0 0-9.57 4.785 4.785 0 0 0 0 9.57z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var SearchSelected = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgSearchSelected
  }, props));
});

var SvgSend = function SvgSend(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M5.79 11.107l4.253 1.949a.75.75 0 0 1 .315.27l3.01 4.583 4.59-12.462-12.169 5.66zm3.433 3.223l-5.535-2.536a.75.75 0 0 1-.004-1.362l15.29-7.112a.75.75 0 0 1 1.02.94l-5.732 15.563a.75.75 0 0 1-1.33.152l-3.71-5.645zm1.17 3.256l.743-.845a.75.75 0 0 1 1.127.99l-2.056 2.34c-.457.519-1.313.196-1.313-.496v-5.751a.75.75 0 0 1 .214-.525l9.356-9.529a.75.75 0 0 1 1.07 1.05l-9.14 9.31v3.456z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var Send = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgSend
  }, props));
});

var SvgSettings = function SvgSettings(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.659 19.642a.75.75 0 0 1-.917-.113l-1.27-1.27a.75.75 0 0 1-.112-.917l1.123-1.867a7.34 7.34 0 0 1-.55-1.32l-2.115-.53a.75.75 0 0 1-.568-.728v-1.793a.75.75 0 0 1 .568-.728l2.101-.524c.142-.452.33-.896.562-1.327L4.359 6.657a.75.75 0 0 1 .112-.916l1.268-1.27a.75.75 0 0 1 .917-.112l1.87 1.122a7.43 7.43 0 0 1 1.32-.549l.53-2.114a.75.75 0 0 1 .727-.568h1.793a.75.75 0 0 1 .728.568l.525 2.103c.451.143.893.33 1.322.56l1.872-1.123a.75.75 0 0 1 .916.112l1.268 1.268a.75.75 0 0 1 .113.916l-1.123 1.872c.226.423.41.865.548 1.318l2.117.53a.75.75 0 0 1 .568.728v1.791a.75.75 0 0 1-.568.728l-2.117.53a7.35 7.35 0 0 1-.548 1.319l1.125 1.87a.75.75 0 0 1-.112.916l-1.27 1.272a.75.75 0 0 1-.916.113l-1.87-1.124c-.428.23-.871.418-1.324.56l-.524 2.102a.75.75 0 0 1-.727.568l-1.793.002a.75.75 0 0 1-.728-.568l-.526-2.102a7.595 7.595 0 0 1-1.323-.56l-1.87 1.123zm1.294-2.527a1.096 1.096 0 0 1 1.116-.012c.458.264.933.465 1.417.599.378.107.666.408.766.792l.439 1.754h.621l.439-1.758a1.1 1.1 0 0 1 .767-.789 6.101 6.101 0 0 0 1.408-.596c.347-.204.774-.2 1.12.006l1.567.942.442-.442-.94-1.564a1.102 1.102 0 0 1-.013-1.118c.254-.44.449-.91.581-1.399.104-.384.408-.682.793-.777l1.774-.445v-.621l-1.772-.443a1.098 1.098 0 0 1-.795-.779 5.928 5.928 0 0 0-.583-1.402 1.101 1.101 0 0 1 .012-1.11l.94-1.568-.44-.44-1.562.937a1.087 1.087 0 0 1-1.119.014 6.204 6.204 0 0 0-1.41-.597 1.094 1.094 0 0 1-.772-.792L12.31 3.75h-.622l-.442 1.77a1.1 1.1 0 0 1-.778.794 5.91 5.91 0 0 0-1.393.578c-.35.208-.782.203-1.122-.005l-1.567-.94-.44.44.939 1.562c.208.344.21.772.011 1.117a6.197 6.197 0 0 0-.6 1.418c-.107.381-.409.673-.792.768l-1.754.438v.622l1.77.443c.386.096.69.394.794.778.133.49.329.96.584 1.402.2.346.196.774-.01 1.114l-.94 1.564.44.442 1.565-.94zm4.05-1.68A3.437 3.437 0 0 1 8.566 12a3.437 3.437 0 0 1 3.435-3.435 3.436 3.436 0 0 1 0 6.87zm0-1.5a1.936 1.936 0 0 0 0-3.87A1.937 1.937 0 0 0 10.066 12c0 1.066.869 1.934 1.935 1.934z",
    id: "settings_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "settings_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#settings_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#settings_svg__a"
  }), React.createElement("g", {
    mask: "url(#settings_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Settings = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgSettings
  }, props));
});

var SvgShare = function SvgShare(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.342 16.169l-3.435-1.8a3.75 3.75 0 1 1 0-4.739l3.435-1.799a3.75 3.75 0 1 1 .62 1.369l-3.358 1.759a3.752 3.752 0 0 1 0 2.082l3.359 1.76a3.75 3.75 0 1 1-.62 1.369zM7 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zm10-5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zm0 10a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5z",
    id: "share_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "share_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#share_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#share_svg__a"
  }), React.createElement("g", {
    mask: "url(#share_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Share = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgShare
  }, props));
});

var SvgSort = function SvgSort(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M17.49 15.84V6.48a.75.75 0 1 1 1.5 0v9.3l1.205-1.206a.75.75 0 0 1 1.06 1.06L18.78 18.11a.748.748 0 0 1-.571.219.748.748 0 0 1-.571-.219l-2.475-2.474a.75.75 0 0 1 1.06-1.061l1.266 1.266zM3.442 7.225a.75.75 0 0 1 0-1.5H14.26a.75.75 0 0 1 0 1.5H3.443zm0 3.683a.75.75 0 0 1 0-1.5h8.817a.75.75 0 0 1 0 1.5H3.443zm0 3.684a.75.75 0 1 1 0-1.5h6.817a.75.75 0 0 1 0 1.5H3.443zm0 3.683a.75.75 0 1 1 0-1.5h4.454a.75.75 0 0 1 0 1.5H3.443z",
    id: "sort_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    opacity: 0.4,
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "sort_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#sort_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#sort_svg__a"
  }), React.createElement("g", {
    mask: "url(#sort_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Sort = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgSort
  }, props));
});

var SvgStarDefault = function SvgStarDefault(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.663 16.133a.725.725 0 0 1 .674 0l3.814 2.005-.728-4.246a.725.725 0 0 1 .208-.642l3.085-3.007-4.263-.62a.725.725 0 0 1-.546-.396L12 5.363l-1.907 3.864a.725.725 0 0 1-.546.396l-4.263.62 3.085 3.007c.17.167.249.407.208.642l-.728 4.246 3.814-2.005zM12 17.594l-4.776 2.511a.725.725 0 0 1-1.052-.764l.912-5.319-3.864-3.766a.725.725 0 0 1 .402-1.237l5.34-.776 2.388-4.839a.725.725 0 0 1 1.3 0l2.388 4.84 5.34.775a.725.725 0 0 1 .402 1.237l-3.864 3.766.912 5.319a.725.725 0 0 1-1.052.764L12 17.595z",
    id: "star-default_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "star-default_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#star-default_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#star-default_svg__a"
  }), React.createElement("g", {
    mask: "url(#star-default_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var StarDefault = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgStarDefault
  }, props));
});

var SvgStarSelected = function SvgStarSelected(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 17.347l-4.941 2.598a.75.75 0 0 1-1.088-.79l.943-5.503-3.997-3.896a.75.75 0 0 1 .416-1.28l5.524-.802 2.47-5.006a.75.75 0 0 1 1.346 0l2.47 5.006 5.524.803a.75.75 0 0 1 .416 1.279l-3.997 3.896.943 5.502a.75.75 0 0 1-1.088.791L12 17.347z",
    id: "star-selected_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "star-selected_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#star-selected_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#star-selected_svg__a"
  }), React.createElement("g", {
    mask: "url(#star-selected_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var StarSelected = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgStarSelected
  }, props));
});

var SvgStructure = function SvgStructure(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.25 13h-5.5v2.5h.75a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h.75v-3.25A.75.75 0 0 1 5 11.5h6.25V9.405A3.001 3.001 0 0 1 12 3.5a3 3 0 0 1 .75 5.905V11.5h6.389a.75.75 0 0 1 .75.75v3.25h.611a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h.889V13H12.75v2.5h.75a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h.75V13zM12 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM4 17v2h2v-2H4zm7 0v2h2v-2h-2zm7 0v2h2v-2h-2z",
    id: "structure_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "structure_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#structure_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#structure_svg__a"
  }), React.createElement("g", {
    mask: "url(#structure_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 1.5h24v24H0z"
  }))));
};

var Structure = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgStructure
  }, props));
});

var SvgTextAlignCenter = function SvgTextAlignCenter(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.951 18.369a.75.75 0 1 1 0-1.5h10a.75.75 0 0 1 0 1.5h-10zm-.908-11.05a.75.75 0 1 1 0-1.5H17.86a.75.75 0 1 1 0 1.5H6.043zm.908 3.683a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 0 1.5h-10zm-.908 3.683a.75.75 0 1 1 0-1.5H17.86a.75.75 0 0 1 0 1.5H6.043z",
    id: "text-align-center_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-align-center_svg__a"
  })));
};

var TextAlignCenter = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextAlignCenter
  }, props));
});

var SvgTextAlignJustify = function SvgTextAlignJustify(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.092 18.266a.75.75 0 0 1 0-1.5H17.91a.75.75 0 0 1 0 1.5H6.092zm0-11.05a.75.75 0 1 1 0-1.5H17.91a.75.75 0 0 1 0 1.5H6.092zm0 3.684a.75.75 0 1 1 0-1.5H17.91a.75.75 0 0 1 0 1.5H6.092zm0 3.683a.75.75 0 0 1 0-1.5H17.91a.75.75 0 0 1 0 1.5H6.092z",
    id: "text-align-justify_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-align-justify_svg__a"
  })));
};

var TextAlignJustify = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextAlignJustify
  }, props));
});

var SvgTextAlignLeft = function SvgTextAlignLeft(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.091 7.225a.75.75 0 0 1 0-1.5H17.91a.75.75 0 1 1 0 1.5H6.09zm0 3.683a.75.75 0 0 1 0-1.5H17.91a.75.75 0 1 1 0 1.5H6.09zm0 3.684a.75.75 0 1 1 0-1.5H17.91a.75.75 0 0 1 0 1.5H6.09zm0 3.683a.75.75 0 1 1 0-1.5h9.454a.75.75 0 0 1 0 1.5H6.091z",
    id: "text-align-left_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-align-left_svg__a"
  })));
};

var TextAlignLeft = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextAlignLeft
  }, props));
});

var SvgTextAlignRight = function SvgTextAlignRight(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M5.933 6.978a.75.75 0 0 1 0-1.5h11.818a.75.75 0 0 1 0 1.5H5.933zm0 3.683a.75.75 0 1 1 0-1.5h11.818a.75.75 0 0 1 0 1.5H5.933zm0 3.684a.75.75 0 1 1 0-1.5h11.818a.75.75 0 0 1 0 1.5H5.933zm0 3.683a.75.75 0 1 1 0-1.5h9.454a.75.75 0 0 1 0 1.5H5.933z",
    id: "text-align-right_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 23.684 0)",
    xlinkHref: "#text-align-right_svg__a"
  })));
};

var TextAlignRight = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextAlignRight
  }, props));
});

var SvgTextBold = function SvgTextBold(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M7.55 17.673V6.327h4.083c.594 0 1.152.044 1.676.131.524.087.978.236 1.362.445.384.21.689.498.916.864.227.367.34.83.34 1.388 0 .244-.035.492-.104.742-.07.25-.166.488-.288.715-.123.227-.271.428-.446.603a1.63 1.63 0 0 1-.593.384v.07a2.95 2.95 0 0 1 1.388.88c.378.426.567 1.016.567 1.772 0 .582-.12 1.086-.358 1.51a3.068 3.068 0 0 1-.96 1.048 4.202 4.202 0 0 1-1.422.602 7.562 7.562 0 0 1-1.728.192H7.549zm3.001-6.912h1.013c.488 0 .85-.105 1.082-.314.233-.21.349-.49.349-.838 0-.35-.116-.6-.35-.75-.232-.152-.593-.228-1.081-.228H10.55v2.13zm0 4.608h1.222c1.164 0 1.746-.42 1.746-1.257 0-.419-.143-.716-.428-.89-.285-.175-.724-.262-1.318-.262h-1.222v2.409z",
    id: "text-bold_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "text-bold_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-bold_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#text-bold_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-bold_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TextBold = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextBold
  }, props));
});

var SvgTextColumns = function SvgTextColumns(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M4.674 7.226a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5h-6zm0 3.682a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5h-6zm0 3.683a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5h-6zm8.652-7.365a.75.75 0 0 1 0-1.5h6a.75.75 0 1 1 0 1.5h-6zm0 3.682a.75.75 0 0 1 0-1.5h6a.75.75 0 1 1 0 1.5h-6zm0 3.683a.75.75 0 0 1 0-1.5h6a.75.75 0 1 1 0 1.5h-6zm0 3.683a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5h-6z",
    id: "text-columns_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "text-columns_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-columns_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-columns_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-columns_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TextColumns = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextColumns
  }, props));
});

var SvgTextImageLeft = function SvgTextImageLeft(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.796 6.979H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 0 1 0 1.5zm0 3.682H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 0 1 0 1.5zm0 3.684H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 0 1 0 1.5zm0 3.683H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 1 1 0 1.5zM19.976 5c1.197 0 2.167.895 2.167 2v9c0 1.105-.97 2-2.167 2h-8.667c-1.196 0-2.166-.895-2.166-2V7c0-1.105.97-2 2.166-2h8.667zm.111 1.5h-8.889c-.307 0-.555.224-.555.5v9c0 .276.248.5.555.5h8.89c.306 0 .555-.224.555-.5V7c0-.276-.25-.5-.556-.5zM15.09 9.276l.971 1.943.515-.686a.5.5 0 0 1 .824.035l1.667 2.667a.5.5 0 0 1-.424.765h-6a.5.5 0 0 1-.448-.724l2-4a.5.5 0 0 1 .895 0z",
    id: "text-image-left_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 24.067 0)",
    xlinkHref: "#text-image-left_svg__a"
  })));
};

var TextImageLeft = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextImageLeft
  }, props));
});

var SvgTextImageRight = function SvgTextImageRight(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M6.796 6.979H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 0 1 0 1.5zm0 3.682H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 0 1 0 1.5zm0 3.684H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 0 1 0 1.5zm0 3.683H2.674a.75.75 0 1 1 0-1.5h4.122a.75.75 0 1 1 0 1.5zM19.976 5c1.197 0 2.167.895 2.167 2v9c0 1.105-.97 2-2.167 2h-8.667c-1.196 0-2.166-.895-2.166-2V7c0-1.105.97-2 2.166-2h8.667zm.111 1.5h-8.889c-.307 0-.555.224-.555.5v9c0 .276.248.5.555.5h8.89c.306 0 .555-.224.555-.5V7c0-.276-.25-.5-.556-.5zm-3.892 2.776a.5.5 0 0 1 .895 0l2 4a.5.5 0 0 1-.447.724h-6a.5.5 0 0 1-.424-.765l1.666-2.667a.5.5 0 0 1 .824-.035l.515.686.971-1.943z",
    id: "text-image-right_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M.033 0h24v24h-24z"
  }), React.createElement("path", {
    d: "M2.033 2h20v20h-20z"
  }), React.createElement("mask", {
    id: "text-image-right_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-image-right_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-image-right_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-image-right_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TextImageRight = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextImageRight
  }, props));
});

var SvgTextItalic = function SvgTextItalic(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.887 7.25l-2.714 9.5H13.5a.75.75 0 1 1 0 1.5h-5a.75.75 0 1 1 0-1.5h1.113l2.714-9.5H10.5a.75.75 0 1 1 0-1.5h5a.75.75 0 1 1 0 1.5h-1.613z",
    id: "text-italic_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "text-italic_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-italic_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-italic_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-italic_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TextItalic = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextItalic
  }, props));
});

var SvgTextOrderedList = function SvgTextOrderedList(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M9.431 7.726a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 0 1.5h-8zm-3.852.75v-.653h.644V6.27h-.568v-.502c.34-.066.558-.151.786-.293h.596v2.347h.54v.653H5.578zm-.061 5v-.455c.696-.641 1.235-1.133 1.235-1.533 0-.265-.149-.39-.362-.39-.195 0-.344.14-.483.279l-.428-.428c.307-.325.586-.473 1.022-.473.594 0 1.012.38 1.012.966 0 .473-.445.994-.845 1.402.149-.018.362-.037.492-.037h.493v.669H5.518zm.061 4.59l.356-.493c.178.164.388.274.593.274.255 0 .42-.092.42-.274 0-.219-.115-.346-.721-.346v-.548c.483 0 .629-.127.629-.328 0-.173-.105-.264-.301-.264-.191 0-.328.082-.51.237l-.393-.474c.283-.237.584-.374.94-.374.638 0 1.048.292 1.048.816 0 .278-.155.488-.465.624v.019c.328.1.556.328.556.693 0 .547-.52.848-1.121.848-.47 0-.812-.155-1.03-.41zm3.852-5.34a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 0 1.5h-8zm0 5a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 0 1.5h-8z",
    id: "text-ordered-list_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 1.889h20v20H2z"
  }), React.createElement("mask", {
    id: "text-ordered-list_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-ordered-list_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-ordered-list_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-ordered-list_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0-.111h24v24H0z"
  }))));
};

var TextOrderedList = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextOrderedList
  }, props));
});

var SvgTextStrikethrough = function SvgTextStrikethrough(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11.874 11.218H17a.75.75 0 1 1 0 1.5h-2.39c.805.753 1.179 1.684 1.197 2.75.031 1.782-1.593 3.275-3.787 3.313-1.605.028-2.842-.733-3.605-2.233-.204-.4-.077-.908.284-1.133.36-.225.818-.082 1.022.319.487.957 1.208 1.401 2.27 1.383 1.43-.025 2.33-.852 2.316-1.623-.02-1.227-.849-2.167-3.46-2.758a.7.7 0 0 1-.064-.018H7a.75.75 0 1 1 0-1.5h1.967c-.494-.61-.717-1.323-.717-2.14 0-1.892 1.592-3.86 3.75-3.86 1.65 0 2.903 1.033 3.684 2.963.17.42.001.912-.377 1.1-.378.189-.822.002-.991-.418-.553-1.365-1.299-1.98-2.316-1.98-1.291 0-2.25 1.185-2.25 2.194 0 .884.498 1.566 2.124 2.141z",
    id: "text-strikethrough_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "text-strikethrough_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-strikethrough_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-strikethrough_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-strikethrough_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TextStrikethrough = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextStrikethrough
  }, props));
});

var SvgTextTable = function SvgTextTable(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12.867 13.66H18.5v-3.275h-5.633v3.275zm-1.5 0v-3.275H5.5v3.275h5.867zm1.5-8.16v3.385H18.5V6a.5.5 0 0 0-.5-.5h-5.133zm-1.5 0H6a.5.5 0 0 0-.5.5v2.885h5.867V5.5zm1.5 13H18a.5.5 0 0 0 .5-.5v-2.84h-5.633v3.34zm-1.5 0v-3.34H5.5V18a.5.5 0 0 0 .5.5h5.367zM6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
    id: "text-table_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M.033 0h24v24h-24z"
  }), React.createElement("path", {
    d: "M2.033 2h20v20h-20z"
  }), React.createElement("mask", {
    id: "text-table_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-table_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-table_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-table_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M-.5.5h24v24h-24z"
  }))));
};

var TextTable = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextTable
  }, props));
});

var SvgTextUnderline = function SvgTextUnderline(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M8.16 18.25a.75.75 0 1 1 0-1.5h7.945a.75.75 0 0 1 0 1.5H8.16zM15.146 6.5a.75.75 0 0 1 1.5 0v3.274a4.75 4.75 0 1 1-9.5 0V6.5a.75.75 0 0 1 1.5 0v3.274a3.25 3.25 0 1 0 6.5 0V6.5z",
    id: "text-underline_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "text-underline_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-underline_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-underline_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-underline_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TextUnderline = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextUnderline
  }, props));
});

var SvgTextUnorderedList = function SvgTextUnorderedList(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M9.5 7.75a.75.75 0 0 1 0-1.5h8a.75.75 0 1 1 0 1.5h-8zm0 5a.75.75 0 1 1 0-1.5h8a.75.75 0 1 1 0 1.5h-8zm0 5a.75.75 0 1 1 0-1.5h8a.75.75 0 1 1 0 1.5h-8zm-3-10a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0 5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0 5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z",
    id: "text-unordered-list_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "text-unordered-list_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#text-unordered-list_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#text-unordered-list_svg__a"
  }), React.createElement("g", {
    mask: "url(#text-unordered-list_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TextUnorderedList = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTextUnorderedList
  }, props));
});

var SvgTimer = function SvgTimer(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12.003 3.58a6.431 6.431 0 1 0 0 12.862 6.431 6.431 0 0 0 0-12.862zm0-1.544a7.974 7.974 0 1 1 0 15.949 7.974 7.974 0 0 1 0-15.949zm3.772 4.905a.772.772 0 1 1 .772 1.337l-4.158 2.4a.772.772 0 0 1-.772-1.336l4.158-2.4zm-3 7.871a.772.772 0 1 1-1.544 0V10.01a.772.772 0 1 1 1.544 0v4.802zm5.195 3.822a.772.772 0 1 1-1.117-1.065l2.044-1.746a.772.772 0 1 1 1.118 1.065l-2.045 1.746zm-5.967 1.49a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z",
    id: "timer_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 22.16)",
    xlinkHref: "#timer_svg__a"
  })));
};

var Timer = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTimer
  }, props));
});

var SvgTrash = function SvgTrash(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M19.15 6.99v11.563c0 1.673-1.443 3.017-3.183 3.017H8.033c-1.74 0-3.183-1.344-3.183-3.017V6.99H4a.75.75 0 0 1 0-1.5h16a.75.75 0 0 1 0 1.5h-.85zm-12.8 0v11.563c0 .82.748 1.517 1.683 1.517h7.934c.935 0 1.683-.697 1.683-1.517V6.99H6.35zm2.5 2.49a.75.75 0 0 1 1.5 0v8.1a.75.75 0 0 1-1.5 0v-8.1zm4.8 0a.75.75 0 1 1 1.5 0v8.1a.75.75 0 1 1-1.5 0v-8.1zM8.8 4.56a.75.75 0 1 1 0-1.5h6.4a.75.75 0 0 1 0 1.5H8.8z",
    fill: "currentColor"
  }));
};

var Trash = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTrash
  }, props));
});

var SvgTrendingDown = function SvgTrendingDown(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M19.5 17.013v-3.998a.75.75 0 1 1 1.5 0v3.998a.75.75 0 1 1-1.5 0zm1.093-.667a.75.75 0 0 1-.343 1.416h-4.232a.75.75 0 1 1 0-1.499h2.326l-5.835-5.522-3.393 3.117a.75.75 0 0 1-1.02-.005l-4.86-4.557a.75.75 0 1 1 1.026-1.093l4.352 4.08 3.395-3.12a.75.75 0 0 1 1.022.008L20.5 16.24c.035.033.066.07.093.107z",
    id: "trending-down_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "trending-down_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#trending-down_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#trending-down_svg__a"
  }), React.createElement("g", {
    mask: "url(#trending-down_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TrendingDown = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTrendingDown
  }, props));
});

var SvgTrendingUp = function SvgTrendingUp(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M19.5 7.75a.75.75 0 1 1 1.5 0v3.997a.75.75 0 1 1-1.5 0V7.75zm1.093.666a.754.754 0 0 1-.093.107l-7.469 7.068a.75.75 0 0 1-1.022.008l-3.395-3.12-4.352 4.08a.75.75 0 0 1-1.025-1.093l4.859-4.556a.75.75 0 0 1 1.02-.005l3.393 3.117 5.835-5.523h-2.326a.75.75 0 1 1 0-1.499h4.232a.75.75 0 0 1 .343 1.416z",
    id: "trending-up_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "trending-up_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#trending-up_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#trending-up_svg__a"
  }), React.createElement("g", {
    mask: "url(#trending-up_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var TrendingUp = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgTrendingUp
  }, props));
});

var SvgUnfullscreen = function SvgUnfullscreen(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M8.872 16.127l-4.664 4.666a.708.708 0 1 1-1-1.002l4.663-4.665H3.708a.708.708 0 0 1 0-1.417H9.58c.39 0 .707.317.707.709v5.874a.708.708 0 1 1-1.415 0v-4.165zm0-8.254V3.708a.708.708 0 1 1 1.415 0v5.874a.708.708 0 0 1-.707.709H3.708a.708.708 0 0 1 0-1.417H7.87L3.207 4.21a.708.708 0 0 1 1.001-1.002l4.664 4.666zm6.256 8.254v4.165a.708.708 0 1 1-1.415 0v-5.874c0-.392.316-.709.707-.709h5.872a.708.708 0 0 1 0 1.417H16.13l4.664 4.665a.708.708 0 0 1-1.001 1.002l-4.664-4.666zm0-8.254l4.664-4.666a.708.708 0 1 1 1 1.002L16.13 8.874h4.163a.708.708 0 0 1 0 1.417H14.42a.708.708 0 0 1-.707-.709V3.708a.708.708 0 1 1 1.415 0v4.165z",
    fill: "currentColor"
  }));
};

var Unfullscreen = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgUnfullscreen
  }, props));
});

var SvgUnlocked = function SvgUnlocked(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M5.75 10.75v7.107c0 1.313 1.131 2.393 2.544 2.393h7.412c1.413 0 2.544-1.08 2.544-2.393V10.75H5.75zm9.5-1.5V6.889C15.25 5.16 13.8 3.75 12 3.75c-2.045 0-2.95.573-3.517 2.342a.75.75 0 0 1-1.428-.458C7.835 3.203 9.339 2.25 12 2.25c2.619 0 4.75 2.072 4.75 4.639V9.25H19a.75.75 0 0 1 .75.75v7.857c0 2.158-1.818 3.893-4.044 3.893H8.294c-2.226 0-4.044-1.735-4.044-3.893V10A.75.75 0 0 1 5 9.25h10.25zm-2.928 7.603l-.27-.866-.255.819c.02-.094.136-.181.256-.181a.75.75 0 1 0 0 1.5c.56 0 1.057-.375 1.189-.92l.553-1.77c.28-1.153-.594-2.185-1.742-2.185-1.148 0-2.022 1.032-1.755 2.138l.579 1.864c.118.498.615.873 1.176.873a.75.75 0 0 0 0-1.5c.12 0 .235.087.269.228zm.028-1.816l-.297.95-.31-.998c-.02-.089.107-.239.31-.239.202 0 .33.15.297.287z",
    id: "unlocked_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "unlocked_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#unlocked_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#unlocked_svg__a"
  }), React.createElement("g", {
    mask: "url(#unlocked_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var Unlocked = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgUnlocked
  }, props));
});

var SvgUpload = function SvgUpload(props) {
  return React.createElement("svg", _extends({
    id: "upload_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 24 24"
  }, props, {
    width: "1.5em",
    height: "1.5em"
  }), React.createElement("style", null, ".upload_svg__st0{fill:none}.upload_svg__st1{fill:#293f4d}"), React.createElement("g", {
    id: "upload_svg___xD83D__xDC7E_-Icons_x2F_System_x2F_Download"
  }, React.createElement("path", {
    id: "upload_svg__Bounds",
    className: "upload_svg__st0",
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    id: "upload_svg__Live-Area",
    className: "upload_svg__st0",
    d: "M2 2h20v20H2z"
  }), React.createElement("g", {
    id: "upload_svg__Download-Icon",
    transform: "translate(3 2)"
  }, React.createElement("g", {
    id: "upload_svg__Icons_x2F_Download"
  }, React.createElement("path", {
    id: "upload_svg__path-1_1_",
    className: "upload_svg__st1",
    d: "M9.8 6.6V19c0 .4-.3.8-.8.8s-.8-.4-.8-.8V6.6L4.5 9.9c-.3.3-.8.2-1.1-.1s-.2-.8.1-1.1l5-4.3c.3-.2.7-.2 1 0l5 4.3c.3.3.3.7.1 1.1-.3.3-.7.3-1.1.1L9.8 6.6zM17 1.2c.4 0 .8.3.8.8s-.4.8-.8.8H1C.6 2.8.2 2.4.2 2s.4-.8.8-.8h16z"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "upload_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -3,
    y: -2,
    width: 24,
    height: 24
  }, React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -2,
    width: 24,
    height: 24,
    id: "upload_svg__mask-2_1_"
  }, React.createElement("g", {
    filter: "url(#upload_svg__Adobe_OpacityMaskFilter)"
  }, React.createElement("path", {
    id: "upload_svg__path-1_2_",
    d: "M9.8 6.6V19c0 .4-.3.8-.8.8s-.8-.4-.8-.8V6.6L4.5 9.9c-.3.3-.8.2-1.1-.1s-.2-.8.1-1.1l5-4.3c.3-.2.7-.2 1 0l5 4.3c.3.3.3.7.1 1.1-.3.3-.7.3-1.1.1L9.8 6.6zM17 1.2c.4 0 .8.3.8.8s-.4.8-.8.8H1C.6 2.8.2 2.4.2 2s.4-.8.8-.8h16z",
    fill: "#fff"
  }))), React.createElement("g", {
    id: "upload_svg___xD83C__xDF08_-Color_x2F_Icons_x2F_Gray-XD",
    mask: "url(#upload_svg__mask-2_1_)"
  }, React.createElement("path", {
    className: "upload_svg__st1",
    d: "M0 0h24v24H0z",
    transform: "translate(-3 -2)"
  })))));
};

var Upload = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgUpload
  }, props));
});

var SvgUserDefault = function SvgUserDefault(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 11.257c1.642 0 2.971-1.319 2.971-2.943S13.642 5.371 12 5.371c-1.642 0-2.971 1.32-2.971 2.943 0 1.624 1.329 2.943 2.971 2.943zm-2.67.46a4.296 4.296 0 0 1-1.673-3.403C7.657 5.93 9.603 4 12 4c2.397 0 4.343 1.93 4.343 4.314a4.296 4.296 0 0 1-1.673 3.402A8.058 8.058 0 0 1 20 19.314a.686.686 0 1 1-1.371 0c0-3.694-2.97-6.686-6.629-6.686-3.66 0-6.629 2.992-6.629 6.686a.686.686 0 1 1-1.371 0 8.058 8.058 0 0 1 5.33-7.598zM4.686 20a.686.686 0 1 1 0-1.371H19.28a.686.686 0 0 1 0 1.371H4.686z",
    id: "user-default_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "user-default_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#user-default_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#user-default_svg__a"
  }), React.createElement("g", {
    mask: "url(#user-default_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var UserDefault = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgUserDefault
  }, props));
});

var SvgUserGroup = function SvgUserGroup(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M12 6.806a1.04 1.04 0 0 0 1.05-1.028A1.04 1.04 0 0 0 12 4.75a1.04 1.04 0 0 0-1.05 1.028A1.04 1.04 0 0 0 12 6.806zm0 1.5c-1.406 0-2.55-1.13-2.55-2.528C9.45 4.38 10.594 3.25 12 3.25s2.55 1.13 2.55 2.528c0 1.398-1.144 2.528-2.55 2.528zm2.751 2.112A2.853 2.853 0 0 0 12 8.306a2.853 2.853 0 0 0-2.751 2.112h5.502zm-7.101.75A4.356 4.356 0 0 1 12 6.806a4.356 4.356 0 0 1 4.35 4.362.75.75 0 0 1-.75.75H8.4a.75.75 0 0 1-.75-.75zm-1.08 4.349a.95.95 0 0 0 .96-.94.95.95 0 0 0-.96-.938.95.95 0 0 0-.96.939.95.95 0 0 0 .96.939zm0 1.5a2.45 2.45 0 0 1-2.46-2.44 2.45 2.45 0 0 1 2.46-2.438 2.45 2.45 0 0 1 2.46 2.439 2.45 2.45 0 0 1-2.46 2.439zm2.564 1.931a2.673 2.673 0 0 0-2.564-1.931 2.673 2.673 0 0 0-2.565 1.931h5.129zm-6.734.75a4.176 4.176 0 0 1 4.17-4.181 4.176 4.176 0 0 1 4.17 4.181.75.75 0 0 1-.75.75H3.15a.75.75 0 0 1-.75-.75zm14.97-4.181a.95.95 0 0 0 .96-.94.95.95 0 0 0-.96-.938.95.95 0 0 0-.96.939.95.95 0 0 0 .96.939zm0 1.5a2.45 2.45 0 0 1-2.46-2.44 2.45 2.45 0 0 1 2.46-2.438 2.45 2.45 0 0 1 2.46 2.439 2.45 2.45 0 0 1-2.46 2.439zm2.564 1.931a2.673 2.673 0 0 0-2.564-1.931 2.673 2.673 0 0 0-2.565 1.931h5.129zm-6.734.75a4.176 4.176 0 0 1 4.17-4.181 4.176 4.176 0 0 1 4.17 4.181.75.75 0 0 1-.75.75h-6.84a.75.75 0 0 1-.75-.75z",
    id: "user-group_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "user-group_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#user-group_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#user-group_svg__a"
  }), React.createElement("g", {
    mask: "url(#user-group_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var UserGroup = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgUserGroup
  }, props));
});

var SvgUserInvite = function SvgUserInvite(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M11 11.257c1.642 0 2.971-1.319 2.971-2.943S12.642 5.371 11 5.371c-1.642 0-2.971 1.32-2.971 2.943 0 1.624 1.329 2.943 2.971 2.943zm-2.67.46a4.296 4.296 0 0 1-1.673-3.403C6.657 5.93 8.603 4 11 4c2.397 0 4.343 1.93 4.343 4.314a4.296 4.296 0 0 1-1.673 3.402A8.058 8.058 0 0 1 19 19.314a.686.686 0 1 1-1.371 0c0-3.694-2.97-6.686-6.629-6.686-3.66 0-6.629 2.992-6.629 6.686a.686.686 0 1 1-1.371 0 8.058 8.058 0 0 1 5.33-7.598zM18.75 7.25h2.45a.75.75 0 1 1 0 1.5h-2.45v2.45a.75.75 0 1 1-1.5 0V8.75H14.8a.75.75 0 1 1 0-1.5h2.45V4.8a.75.75 0 1 1 1.5 0v2.45zM3.686 20a.686.686 0 1 1 0-1.371H18.28a.686.686 0 0 1 0 1.371H3.686z",
    id: "user-invite_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "user-invite_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#user-invite_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#user-invite_svg__a"
  }), React.createElement("g", {
    mask: "url(#user-invite_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var UserInvite = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgUserInvite
  }, props));
});

var SvgVideoOff = function SvgVideoOff(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M13.568 18.75H5.411c-1.324 0-2.161-.678-2.161-1.893V8.432l1.5 1.5v6.925c0 .309.104.393.662.393h6.656l1.5 1.5zM6.432 5.25h8.862c1.077 0 1.691.745 1.691 1.893v.775l2.562-1.944a.75.75 0 0 1 1.203.597V17.43a.75.75 0 0 1-1.203.597l-1.41-1.07a2.293 2.293 0 0 0-.046-.047l-2.57-2.57a.751.751 0 0 1 1.168-.365l2.561 1.944V8.082l-2.561 1.944a.75.75 0 0 1-1.204-.597V7.143c0-.376-.013-.393-.19-.393H7.931l-1.5-1.5zm-3.462.78a.75.75 0 0 1 1.06-1.06l13 13a.75.75 0 0 1-1.06 1.06l-13-13z",
    id: "video-off_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "video-off_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#video-off_svg__a"
  })), React.createElement("use", {
    fill: "#2B3C41",
    fillRule: "nonzero",
    xlinkHref: "#video-off_svg__a"
  }), React.createElement("g", {
    mask: "url(#video-off_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var VideoOff = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgVideoOff
  }, props));
});

var SvgVideoOn = function SvgVideoOn(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M16.985 16.857c0 1.215-.837 1.893-2.161 1.893H5.41c-1.324 0-2.161-.678-2.161-1.893V7.714c0-1.528.77-2.464 2.162-2.464h9.882c1.077 0 1.691.745 1.691 1.893v.775l2.562-1.944a.75.75 0 0 1 1.203.597V17.43a.75.75 0 0 1-1.203.597l-2.562-1.944v.775zm-.296-6.831a.75.75 0 0 1-1.204-.597V7.143c0-.376-.013-.393-.19-.393H5.411c-.492 0-.662.207-.662.964v9.143c0 .309.104.393.662.393h9.412c.557 0 .661-.084.661-.393v-2.286a.75.75 0 0 1 1.204-.597l2.561 1.944V8.082l-2.561 1.944z",
    id: "video-on_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "video-on_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#video-on_svg__a"
  })), React.createElement("use", {
    fill: "#2B3C41",
    fillRule: "nonzero",
    xlinkHref: "#video-on_svg__a"
  }), React.createElement("g", {
    mask: "url(#video-on_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var VideoOn = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgVideoOn
  }, props));
});

var SvgViewCard = function SvgViewCard(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M5 10.704V5h14v5.704H5zm1.556-1.556h10.888V6.556H6.556v2.592zM5 19v-5.704h14V19H5zm1.556-1.556h10.888v-2.592H6.556v2.592z",
    id: "view-card_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M4 2h20v20H4z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#view-card_svg__a"
  })));
};

var ViewCard = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgViewCard
  }, props));
});

var SvgViewGallery = function SvgViewGallery(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M5.778 11.222A.778.778 0 0 1 5 10.444V5.778c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778H5.778zm.778-1.555h3.11V6.556h-3.11v3.11zM5.778 19A.778.778 0 0 1 5 18.222v-4.666c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778H5.778zm.778-1.556h3.11v-3.11h-3.11v3.11zm7-6.222a.778.778 0 0 1-.778-.778V5.778c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778h-4.666zm.777-1.555h3.111V6.556h-3.11v3.11zM13.556 19a.778.778 0 0 1-.778-.778v-4.666c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778h-4.666zm.777-1.556h3.111v-3.11h-3.11v3.11z",
    id: "view-gallery_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#view-gallery_svg__a"
  })));
};

var ViewGallery = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgViewGallery
  }, props));
});

var SvgViewGallerySelected = function SvgViewGallerySelected(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M5.778 11.222A.778.778 0 0 1 5 10.444V5.778c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778H5.778zm0 7.778A.778.778 0 0 1 5 18.222v-4.666c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778H5.778zm7.778-7.778a.778.778 0 0 1-.778-.778V5.778c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778h-4.666zm0 7.778a.778.778 0 0 1-.778-.778v-4.666c0-.43.348-.778.778-.778h4.666c.43 0 .778.348.778.778v4.666c0 .43-.348.778-.778.778h-4.666z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var ViewGallerySelected = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgViewGallerySelected
  }, props));
});

var SvgViewList = function SvgViewList(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M5.677 8.462A.677.677 0 0 1 5 7.785V5.677C5 5.303 5.303 5 5.677 5h12.646c.374 0 .677.303.677.677v2.108a.677.677 0 0 1-.677.677H5.677zm.678-1.354h11.29v-.753H6.355v.753zm-.678 6.623A.677.677 0 0 1 5 13.054v-2.108c0-.374.303-.677.677-.677h12.646c.374 0 .677.303.677.677v2.108a.677.677 0 0 1-.677.677H5.677zm.678-1.355h11.29v-.752H6.355v.752zM5.677 19A.677.677 0 0 1 5 18.323v-2.108c0-.374.303-.677.677-.677h12.646c.374 0 .677.303.677.677v2.108a.677.677 0 0 1-.677.677H5.677zm.678-1.355h11.29v-.753H6.355v.753z",
    id: "view-list_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#view-list_svg__a"
  })));
};

var ViewList = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgViewList
  }, props));
});

var SvgVolumeHigh = function SvgVolumeHigh(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M2 8.66c0-.943.804-1.708 1.794-1.708h2.438c.357-.304 1.163-.978 2.36-1.974l.011-.01 1.752-1.458.797-.661.088-.061a1.994 1.994 0 0 1 1.015-.288l.087.003.034.002c.69.063 1.225.574 1.382 1.204l.017.137v16.308l-.017.14a1.595 1.595 0 0 1-1.416 1.202l-.112.004c-.328 0-.66-.098-1.07-.344l-.796-.639L8.61 19.11l-.015-.013a289.332 289.332 0 0 1-2.36-1.909H3.795c-.99 0-1.794-.764-1.794-1.707V8.66zm10.526-4.73c-.05-.132-.156-.226-.259-.24l-.037-.002a.664.664 0 0 0-.302.093l-.751.625-1.751 1.457-.012.01a244.802 244.802 0 0 0-2.5 2.095l-.183.173H3.794c-.3 0-.545.233-.545.519v6.82c0 .288.244.52.545.52h2.937l.183.173c.07.066 1.053.863 2.488 2.017l.015.012 1.752 1.406.577.463c.125.1.163.13.162.132l-.02-.009c.146.085.256.117.317.118l.053-.001c.105-.01.215-.105.268-.242V3.93zm3.547 10.022a.546.546 0 0 0-.26.748c.104.194.31.305.522.305.087 0 .176-.02.264-.059 1.182-.569 1.917-1.693 1.917-2.94 0-1.249-.735-2.373-1.917-2.94a.599.599 0 0 0-.786.246.546.546 0 0 0 .26.748c.785.378 1.273 1.122 1.273 1.946 0 .824-.488 1.57-1.273 1.946zm-.678-8.365c.06-.302.373-.5.686-.44C19.51 5.784 22 8.656 22 11.974c0 3.321-2.489 6.193-5.92 6.828l-.114.011a.577.577 0 0 1-.57-.449.558.558 0 0 1 .461-.653c2.882-.534 4.973-2.947 4.973-5.735 0-2.79-2.09-5.201-4.973-5.736a.557.557 0 0 1-.462-.653z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M10.364 20.517L8.61 19.11l-.015-.013a289.332 289.332 0 0 1-2.36-1.909H3.795c-.99 0-1.794-.764-1.794-1.707V8.66c0-.943.804-1.708 1.794-1.708h2.438c.357-.304 1.163-.978 2.36-1.974l.011-.01 1.752-1.458.797-.661.088-.061a1.994 1.994 0 0 1 1.015-.288l.087.003.034.002c.69.063 1.225.574 1.382 1.204l.017.137v16.308l-.017.14a1.595 1.595 0 0 1-1.416 1.202l-.112.004c-.328 0-.66-.098-1.07-.344l-.796-.639zM8.47 19.253l.015.013 1.753 1.407.807.647.011.007c.432.26.8.373 1.173.373l.119-.004h.01a1.795 1.795 0 0 0 1.593-1.353l.003-.012.02-.164V3.834l-.02-.162-.003-.012c-.176-.705-.776-1.283-1.558-1.354l-.04-.002-.09-.004h-.008c-.391 0-.757.108-1.116.314l-.007.004-.102.071-.803.668c-.598.496-1.195.993-1.753 1.458l-.012.01A427.756 427.756 0 0 0 6.16 6.752H3.794c-1.092 0-1.994.846-1.994 1.908v6.82c0 1.064.902 1.908 1.994 1.908h2.37c.383.316 1.164.947 2.307 1.865zm3.436.952a2.007 2.007 0 0 1-.018-.01l.019.008-.016-.014-.002-.001a10.723 10.723 0 0 0-.144-.117l-.578-.463-1.75-1.406-.016-.013a196.104 196.104 0 0 1-2.488-2.016L6.73 16H3.794a.532.532 0 0 1-.545-.52V8.66c0-.286.244-.519.545-.519h2.937l.183-.173c.075-.07 1.049-.887 2.5-2.095l.012-.01.128.153-.012.01a256.392 256.392 0 0 0-2.49 2.087l-.241.228H3.794c-.2 0-.345.152-.345.319v6.82c0 .168.145.32.345.32h3.017l.24.227.004.004.013.01.042.037.147.121.515.42 1.755 1.415.016.012 1.75 1.406m0 0l.578.463.13.104.03.026a.842.842 0 0 0 .16.064.12.12 0 0 0 .015.003l.036-.001a.099.099 0 0 0 .037-.023.224.224 0 0 0 .047-.062V3.973a.224.224 0 0 0-.045-.06.108.108 0 0 0-.037-.024h-.017a.465.465 0 0 0-.188.06l-.734.61-1.751 1.457-.128-.153 1.75-1.457.752-.625a.664.664 0 0 1 .302-.093l.037.002c.103.014.209.108.26.24v16.14c-.054.136-.164.231-.269.24l-.053.002a.393.393 0 0 1-.116-.024 1.062 1.062 0 0 1-.176-.08l-.006-.003m.074-.176l.004-.01h.001l-.005.01zm3.655-5.236a.746.746 0 0 1 .35-1.021c.721-.345 1.16-1.024 1.16-1.766 0-.741-.439-1.419-1.16-1.765a.747.747 0 0 1-.35-1.021v-.002a.799.799 0 0 1 1.05-.333c1.246.599 2.03 1.79 2.03 3.12s-.784 2.522-2.03 3.122l-.006.002a.848.848 0 0 1-.345.076.791.791 0 0 1-.699-.41v-.002zm.963-5.728a.599.599 0 0 0-.786.247.546.546 0 0 0 .26.748c.785.378 1.273 1.122 1.273 1.946 0 .824-.488 1.57-1.273 1.946a.546.546 0 0 0-.26.748c.104.194.31.305.522.305.087 0 .176-.02.264-.059 1.182-.569 1.917-1.693 1.917-2.94 0-1.249-.735-2.373-1.917-2.94zm-.742-2.825a.557.557 0 0 1-.462-.653c.06-.302.373-.5.686-.44C19.51 5.784 22 8.656 22 11.974c0 3.321-2.489 6.193-5.92 6.828l-.114.011a.577.577 0 0 1-.57-.449.558.558 0 0 1 .461-.653c2.882-.534 4.973-2.947 4.973-5.735 0-2.79-2.09-5.201-4.973-5.736zm.26-1.29c-.41-.078-.835.18-.918.597-.087.42.203.812.622.89 2.794.518 4.81 2.853 4.81 5.539 0 2.685-2.016 5.02-4.81 5.538-.418.078-.708.468-.622.89.076.368.41.61.767.61h.01l.133-.014.008-.001c3.518-.651 6.083-3.6 6.083-7.025 0-3.421-2.564-6.37-6.082-7.024z",
    fill: "currentColor"
  }));
};

var VolumeHigh = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgVolumeHigh
  }, props));
});

var SvgVolumeHighOutlined = function SvgVolumeHighOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), React.createElement("g", {
    clipPath: "url(#volume-high-outlined_svg__clip0)"
  }, React.createElement("path", {
    d: "M15.714 4.363a.782.782 0 0 0-.92.62c-.04.21 0 .41.12.59.12.17.3.29.5.33 2.92.57 5.04 3.13 5.04 6.1 0 2.97-2.12 5.53-5.04 6.1-.21.04-.38.16-.5.33s-.16.38-.12.59c.07.37.39.63.78.63l.13-.01c3.65-.71 6.3-3.92 6.3-7.64.01-3.72-2.64-6.93-6.29-7.64z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M15.89 8.875a.806.806 0 0 0-1.05.33c-.2.38-.03.84.35 1.02.72.35 1.16 1.02 1.16 1.77 0 .74-.44 1.42-1.16 1.77-.39.19-.55.64-.35 1.02.14.26.42.41.7.41.12 0 .23-.03.34-.08h.01c1.25-.6 2.03-1.79 2.03-3.12 0-1.32-.79-2.52-2.03-3.12z",
    fill: "#fff"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.318 6.393a5.73 5.73 0 0 1 4.636 5.61c0 2.729-2.114 5.057-4.54 5.52-1.642.313-1.622 2.681.29 2.681 1.05 0 6.8-1.881 6.8-8.2.01-3.961-2.81-7.376-6.693-8.132a1.296 1.296 0 0 0-1.508 1.017 1.3 1.3 0 0 0 1.013 1.504h.002zm-.194-1.91c.18-.12.39-.16.59-.12 3.65.71 6.3 3.92 6.29 7.64 0 3.72-2.65 6.93-6.3 7.64-.418.032-.825-.175-.91-.62a.79.79 0 0 1 .62-.92c2.92-.57 5.04-3.13 5.04-6.1 0-2.97-2.12-5.53-5.04-6.1a.813.813 0 0 1-.5-.33.786.786 0 0 1 .21-1.09z",
    fill: "#536872"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.42 11.995c0-1.525-.913-2.893-2.312-3.57l-.004-.002c-.606-.287-1.37-.073-1.704.545l-.002.004a1.247 1.247 0 0 0 .575 1.704c.562.274.877.778.877 1.32 0 .533-.317 1.047-.879 1.32-.628.306-.912 1.058-.573 1.702l.002.004c.234.435.691.673 1.14.673.2 0 .383-.058.567-.129 1.411-.678 2.313-2.036 2.313-3.57zm-2.07 0c0-.75-.44-1.42-1.16-1.77a.747.747 0 0 1-.35-1.02c.2-.37.67-.51 1.05-.33 1.24.6 2.01 1.8 2.03 3.12.02 1.33-.79 2.359-1.557 2.857-.3.194-.587.343-.823.343-.28 0-.56-.15-.7-.41-.2-.38-.04-.83.35-1.02.72-.35 1.16-1.03 1.16-1.77z",
    fill: "#536872"
  }), React.createElement("path", {
    d: "M10.99 2.305c-.328-.008-.844.056-1.22.37-1.622 1.359-3.273 2.683-4.87 4.07H2.53c-1.09 0-1.99.85-1.99 1.91v6.82c0 1.06.9 1.91 1.99 1.91H4.9c1.6 1.348 3.26 2.622 4.89 3.93l.01.01c.43.26.8.37 1.17.37.852 0 1.74-.613 1.74-1.52V3.825c0-.819-.866-1.52-1.72-1.52zm-.24 17.71c-1.752-1.366-3.565-2.71-5.2-4.22H2.53c-.2 0-.35-.15-.35-.32v-6.82c0-.17.15-.32.35-.32h3.02c1.64-1.572 3.478-2.934 5.22-4.39.097-.08.3-.062.3.14v15.767c0 .206-.194.261-.32.163z",
    fill: "#fff"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.745 15.295l.143.133c1.315 1.214 2.745 2.318 4.184 3.43l.497.384V4.76C8.941 6.093 7.271 7.377 5.75 8.835H2.68v6.46h3.065zm-.196-6.96H2.53c-.2 0-.35.15-.35.32v6.82c0 .17.15.32.35.32h3.02c1.333 1.23 2.784 2.351 4.224 3.464l.976.756c.126.098.32.043.32-.163V4.086c0-.203-.203-.222-.3-.14-1.744 1.456-3.576 2.814-5.22 4.39z",
    fill: "#536872"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.996 1.805c-.379-.008-1.038.06-1.548.487C7.885 3.6 6.27 4.899 4.713 6.245H2.529c-1.344 0-2.49 1.053-2.49 2.41v6.82c0 1.358 1.146 2.41 2.49 2.41h2.188a130.381 130.381 0 0 0 4.823 3.868c.49.296.948.442 1.43.442 1.104 0 2.242-.844 2.242-2.02 0-6.432.006-10.01.006-16.443 0-1.095-1.207-1.924-2.222-1.927zm-1.227.87c.376-.314.899-.378 1.227-.37.972 0 1.713.875 1.713 1.427v16.443c0 .907-.888 1.52-1.74 1.52-.359 0-.943-.19-1.18-.38-1.63-1.308-3.29-2.582-4.89-3.93H2.53c-1.09 0-1.99-.85-1.99-1.91v-6.82c0-1.06.9-1.91 1.99-1.91H4.9c1.597-1.387 3.248-2.711 4.87-4.07z",
    fill: "#536872"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "volume-high-outlined_svg__clip0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M.08 0h24v24h-24z"
  }))));
};

var VolumeHighOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgVolumeHighOutlined
  }, props));
});

var SvgVolumeLow = function SvgVolumeLow(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M2 8.66c0-.943.804-1.708 1.794-1.708h2.438c.357-.304 1.163-.978 2.36-1.974l.011-.01 1.752-1.458.797-.661.088-.061a1.994 1.994 0 0 1 1.015-.288l.087.003.034.002c.69.063 1.225.574 1.382 1.204l.017.137v16.308l-.017.14a1.595 1.595 0 0 1-1.416 1.202l-.112.004c-.328 0-.66-.098-1.07-.344l-.796-.639L8.61 19.11l-.015-.013a289.332 289.332 0 0 1-2.36-1.909H3.795c-.99 0-1.794-.764-1.794-1.707V8.66zm10.526-4.73c-.05-.132-.156-.226-.259-.24l-.037-.002a.664.664 0 0 0-.302.093l-.751.625-1.751 1.457-.012.01a244.802 244.802 0 0 0-2.5 2.095l-.183.173H3.794c-.3 0-.545.233-.545.519v6.82c0 .288.244.52.545.52h2.937l.183.173c.07.066 1.053.863 2.488 2.017l.015.012 1.752 1.406.577.463c.125.1.163.13.162.132l-.02-.009c.146.085.256.117.317.118l.053-.001c.105-.01.215-.105.268-.242V3.93zm3.547 10.022a.546.546 0 0 0-.26.748c.104.194.31.305.522.305.087 0 .176-.02.264-.059 1.182-.569 1.917-1.693 1.917-2.94 0-1.249-.735-2.373-1.917-2.94a.599.599 0 0 0-.786.246.546.546 0 0 0 .26.748c.785.378 1.273 1.122 1.273 1.946 0 .824-.488 1.57-1.273 1.946z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M10.364 20.517L8.61 19.11l-.015-.013a289.332 289.332 0 0 1-2.36-1.909H3.795c-.99 0-1.794-.764-1.794-1.707V8.66c0-.943.804-1.708 1.794-1.708h2.438c.357-.304 1.163-.978 2.36-1.974l.011-.01 1.752-1.458.797-.661.088-.061a1.994 1.994 0 0 1 1.015-.288l.087.003.034.002c.69.063 1.225.574 1.382 1.204l.017.137v16.308l-.017.14a1.595 1.595 0 0 1-1.416 1.202l-.112.004c-.328 0-.66-.098-1.07-.344l-.796-.639zM8.47 19.253l.015.013 1.753 1.407.807.647.011.007c.432.26.8.373 1.173.373l.119-.004h.01a1.795 1.795 0 0 0 1.593-1.353l.003-.012.02-.164V3.834l-.02-.162-.003-.012c-.176-.705-.776-1.283-1.558-1.354l-.04-.002-.09-.004h-.008c-.391 0-.757.108-1.116.314l-.007.004-.102.071-.803.668c-.598.496-1.195.993-1.753 1.458l-.012.01A427.756 427.756 0 0 0 6.16 6.752H3.794c-1.092 0-1.994.846-1.994 1.908v6.82c0 1.064.902 1.908 1.994 1.908h2.37c.383.316 1.164.947 2.307 1.865zm3.436.952a2.007 2.007 0 0 1-.018-.01l.019.008-.016-.014-.002-.001a10.723 10.723 0 0 0-.144-.117l-.578-.463-1.75-1.406-.016-.013a196.104 196.104 0 0 1-2.488-2.016L6.73 16H3.794a.532.532 0 0 1-.545-.52V8.66c0-.286.244-.519.545-.519h2.937l.183-.173c.075-.07 1.049-.887 2.5-2.095l.012-.01.128.153-.012.01a256.392 256.392 0 0 0-2.49 2.087l-.241.228H3.794c-.2 0-.345.152-.345.319v6.82c0 .168.145.32.345.32h3.017l.24.227.004.004.013.01.042.037.147.121.515.42 1.755 1.415.016.012 1.75 1.406m0 0l.578.463.13.104.03.026a.842.842 0 0 0 .16.064.169.169 0 0 0 .015.003l.036-.001a.099.099 0 0 0 .037-.023.224.224 0 0 0 .047-.062V3.973a.224.224 0 0 0-.045-.06.108.108 0 0 0-.037-.024h-.017a.465.465 0 0 0-.188.06l-.734.61-1.751 1.457-.128-.153 1.75-1.457.752-.625a.664.664 0 0 1 .302-.093l.037.002c.103.014.209.108.26.24v16.14c-.054.136-.164.231-.269.24l-.053.002a.393.393 0 0 1-.116-.024 1.062 1.062 0 0 1-.176-.08l-.006-.003m.074-.176l.004-.01h.001l-.005.01zm3.655-5.236a.746.746 0 0 1 .35-1.021c.721-.345 1.16-1.024 1.16-1.766 0-.741-.439-1.419-1.16-1.765a.747.747 0 0 1-.35-1.021v-.002a.799.799 0 0 1 1.05-.333c1.246.599 2.03 1.79 2.03 3.12s-.784 2.522-2.03 3.122l-.006.002a.848.848 0 0 1-.345.076.791.791 0 0 1-.699-.41v-.002zm.963-5.728a.599.599 0 0 0-.786.247.546.546 0 0 0 .26.748c.785.378 1.273 1.122 1.273 1.946 0 .824-.488 1.57-1.273 1.946a.546.546 0 0 0-.26.748c.104.194.31.305.522.305.087 0 .176-.02.264-.059 1.182-.569 1.917-1.693 1.917-2.94 0-1.249-.735-2.373-1.917-2.94z",
    fill: "currentColor"
  }));
};

var VolumeLow = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgVolumeLow
  }, props));
});

var SvgVolumeLowOutlined = function SvgVolumeLowOutlined(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M10.99 2.305c-.328-.008-.844.056-1.22.37-1.622 1.359-3.273 2.683-4.87 4.07H2.53c-1.09 0-1.99.85-1.99 1.91v6.82c0 1.06.9 1.91 1.99 1.91H4.9c1.6 1.348 3.26 2.622 4.89 3.93l.01.01c.43.26.8.37 1.17.37.852 0 1.74-.613 1.74-1.52V3.825c0-.819-.866-1.52-1.72-1.52zm-.24 17.71c-1.752-1.366-3.565-2.71-5.2-4.22H2.53c-.2 0-.35-.15-.35-.32v-6.82c0-.17.15-.32.35-.32h3.02c1.64-1.572 3.478-2.934 5.22-4.39.097-.08.3-.062.3.14v15.767c0 .206-.194.261-.32.163zM15.89 8.875a.806.806 0 0 0-1.05.33c-.2.38-.03.84.35 1.02.72.35 1.16 1.02 1.16 1.77 0 .74-.44 1.42-1.16 1.77-.39.19-.55.64-.35 1.02.14.26.42.41.7.41.12 0 .23-.03.34-.08h.01c1.25-.6 2.03-1.79 2.03-3.12 0-1.32-.79-2.52-2.03-3.12z",
    fill: "#fff"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.108 8.425c1.4.677 2.312 2.044 2.312 3.57 0 1.535-.902 2.893-2.314 3.571l-.102.05h-.026c-.13.047-.276.08-.438.08-.449 0-.906-.239-1.14-.674l-.002-.004c-.34-.644-.056-1.396.573-1.702.562-.274.879-.787.879-1.32 0-.542-.315-1.046-.877-1.32a1.247 1.247 0 0 1-.575-1.704l.002-.004c.334-.618 1.098-.832 1.704-.545l.004.002zm-.918 1.8c.72.35 1.16 1.02 1.16 1.77 0 .74-.44 1.42-1.16 1.77-.39.19-.55.64-.35 1.02.14.26.42.41.7.41.12 0 .23-.03.34-.08h.01c1.25-.6 2.03-1.79 2.03-3.12 0-1.32-.79-2.52-2.03-3.12a.806.806 0 0 0-1.05.33c-.2.38-.03.84.35 1.02zM5.745 15.295l.143.133c1.315 1.214 2.745 2.318 4.184 3.43l.497.384V4.76C8.941 6.093 7.271 7.377 5.75 8.835H2.68v6.46h3.065zm-.196-6.96H2.53c-.2 0-.35.15-.35.32v6.82c0 .17.15.32.35.32h3.02c1.333 1.23 2.784 2.351 4.224 3.464l.976.756c.126.098.32.043.32-.163V4.086c0-.203-.203-.222-.3-.14-1.744 1.456-3.576 2.814-5.22 4.39z",
    fill: "#536872"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.996 1.805c-.379-.008-1.038.06-1.548.487C7.885 3.6 6.27 4.899 4.713 6.245H2.529c-1.344 0-2.49 1.053-2.49 2.41v6.82c0 1.358 1.146 2.41 2.49 2.41h2.188a130.381 130.381 0 0 0 4.823 3.868c.49.296.948.442 1.43.442 1.104 0 2.242-.844 2.242-2.02 0-6.432.006-10.01.006-16.443 0-1.095-1.207-1.924-2.222-1.927zm-1.227.87c.376-.314.899-.378 1.227-.37.972 0 1.713.875 1.713 1.427v16.443c0 .907-.888 1.52-1.74 1.52-.359 0-.943-.19-1.18-.38-1.63-1.308-3.29-2.582-4.89-3.93H2.53c-1.09 0-1.99-.85-1.99-1.91v-6.82c0-1.06.9-1.91 1.99-1.91H4.9c1.597-1.387 3.248-2.711 4.87-4.07z",
    fill: "#536872"
  }));
};

var VolumeLowOutlined = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgVolumeLowOutlined
  }, props));
});

var SvgWarning = function SvgWarning(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 20 18",
    fill: "none"
  }, props), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.923 15.254a.5.5 0 0 0 .435.746h15.284a.5.5 0 0 0 .435-.746L10.435 1.768a.5.5 0 0 0-.87 0L1.923 15.254zM11.74 1.027l7.642 13.486c.755 1.333-.208 2.986-1.74 2.986H2.358c-1.533 0-2.496-1.653-1.74-2.986L8.26 1.028c.766-1.352 2.714-1.352 3.48 0z"
  }), React.createElement("path", {
    d: "M10.678 10.928a.705.705 0 0 1-1.41 0L9 6.205c0-.39.584-.705.973-.705.39 0 1.027.316 1.027.705l-.322 4.723zM10 12.517c.422 0 .764.32.764.716v.096c0 .395-.342.716-.764.716s-.764-.32-.764-.716v-.096c0-.395.342-.716.764-.716z"
  })));
};

var Warning = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgWarning
  }, props));
});

var SvgWorkSpace = function SvgWorkSpace(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M10 13.467v-.01a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.01l5.5-1.582v-3.37h-15v3.37l5.5 1.582zm0 1.56l-5.915-1.7A1.5 1.5 0 0 1 3 11.885v-3.37a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5v3.37a1.5 1.5 0 0 1-1.085 1.442L14 15.027v.43a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-.43zm9.25-.012a.75.75 0 1 1 1.5 0v4c0 1.224-.912 2.25-2.083 2.25H5.333c-1.171 0-2.083-1.026-2.083-2.25v-4a.75.75 0 1 1 1.5 0v4c0 .432.282.75.583.75h13.334c.3 0 .583-.318.583-.75v-4zm-7.75-1.058v1h1v-1h-1zM9.75 5.485a.75.75 0 1 1-1.5 0V4.82c0-1.125.809-2.084 1.875-2.084h3.75c1.066 0 1.875.959 1.875 2.084v.666a.75.75 0 1 1-1.5 0V4.82c0-.348-.199-.584-.375-.584h-3.75c-.176 0-.375.236-.375.584v.666z",
    id: "work-space_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "work-space_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#work-space_svg__a"
  })), React.createElement("use", {
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#work-space_svg__a"
  }), React.createElement("g", {
    mask: "url(#work-space_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var WorkSpace = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgWorkSpace
  }, props));
});

var SvgZoomIn = function SvgZoomIn(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0zm1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75zm-10.5-4a.75.75 0 1 1 1.5 0v8a.75.75 0 1 1-1.5 0V8zM8 12.75a.75.75 0 1 1 0-1.5h8a.75.75 0 1 1 0 1.5H8z",
    id: "zoom-in_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "zoom-in_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#zoom-in_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#zoom-in_svg__a"
  }), React.createElement("g", {
    mask: "url(#zoom-in_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var ZoomIn = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgZoomIn
  }, props));
});

var SvgZoomOut = function SvgZoomOut(props) {
  return React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0zm1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75zM8 12.75a.75.75 0 1 1 0-1.5h8a.75.75 0 1 1 0 1.5H8z",
    id: "zoom-out_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M2 2h20v20H2z"
  }), React.createElement("mask", {
    id: "zoom-out_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#zoom-out_svg__a"
  })), React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#zoom-out_svg__a"
  }), React.createElement("g", {
    mask: "url(#zoom-out_svg__b)",
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var ZoomOut = (function (props) {
  return IconWrap(_objectSpread({
    children: SvgZoomOut
  }, props));
});

exports.AddIcon = Add;
exports.AlarmIcon = Alarm;
exports.AnimationNextIcon = AnimationNext;
exports.AnimationPreviousIcon = AnimationPrevious;
exports.AnnotationsIcon = Annotations;
exports.ArrowIcon = Arrow;
exports.AttachmentIcon = Attachment;
exports.AudioOffIcon = AudioOff;
exports.AudioOnIcon = AudioOn;
exports.BackIcon = Back;
exports.CalendarIcon = Calendar;
exports.CaretDownIcon = CaretDown;
exports.CaretLeftIcon = CaretLeft;
exports.CaretRightIcon = CaretRight;
exports.CaretUpIcon = CaretUp;
exports.CategoryIcon = Category;
exports.CheckIcon = Check;
exports.CheckOutlinedIcon = CheckOutlined;
exports.ClockIcon = Clock;
exports.CloseIcon = Close;
exports.ClosedCaptionActiveOutlinedIcon = ClosedCaptionActiveOutlined;
exports.ClosedCaptionInactiveOutlinedIcon = ClosedCaptionInactiveOutlined;
exports.CommentIcon = Comment;
exports.CopyIcon = Copy;
exports.CorporationIcon = Corporation;
exports.DataSourceIcon = DataSource;
exports.DocCenterIcon = DocCenter;
exports.DocumentArticleIcon = DocumentArticle;
exports.DocumentDefaultIcon = DocumentDefault;
exports.DocumentExternalIcon = DocumentExternal;
exports.DownloadIcon = Download;
exports.EditIcon = Edit;
exports.EmailIcon = Email;
exports.EmailBlastIcon = EmailBlast;
exports.ErrorFilledIcon = ErrorFilled;
exports.ErrorOutlinedIcon = ErrorOutlined;
exports.ExitIcon = Exit;
exports.ExitFullScreenOutlinedIcon = ExitFullScreenOutlined;
exports.ExitFullscreenIcon = ExitFullscreen;
exports.ExitFullscreenSquareIcon = ExitFullscreenSquare;
exports.FilterIcon = Filter;
exports.FitScreenIcon = FitScreen;
exports.FitWidthIcon = FitWidth;
exports.FolderDefaultIcon = FolderDefault;
exports.FolderDynamicIcon = FolderDynamic;
exports.Forward15SecsIcon = Forward15Secs;
exports.FullScreenOutlinedIcon = FullScreenOutlined;
exports.FullscreenIcon = Fullscreen;
exports.FullscreenSquareIcon = FullscreenSquare;
exports.GlobalIcon = Global;
exports.HeartDefaultIcon = HeartDefault;
exports.HeartSelectedIcon = HeartSelected;
exports.HomeIcon = Home;
exports.HotIcon = Hot;
exports.ImageIcon = Image;
exports.InfoIcon = Info;
exports.InsightsIcon = Insights;
exports.InteractiveContentIcon = InteractiveContent;
exports.LineIcon = Line;
exports.LinkIcon = Link;
exports.LocationIcon = Location;
exports.LockedIcon = Locked;
exports.MeetingSpaceIcon = MeetingSpace;
exports.MenuIcon = Menu;
exports.MoreIcon = More;
exports.MoveIcon = Move;
exports.MuteIcon = Mute;
exports.MutedOutlinedIcon = MutedOutlined;
exports.NewIcon = New;
exports.NewsCenterIcon = NewsCenter;
exports.NextIcon = Next;
exports.NotificationIcon = Notification;
exports.OpenIcon = Open;
exports.OvalIcon = Oval;
exports.PageBackIcon = PageBack;
exports.PageDownIcon = PageDown;
exports.PageForwardIcon = PageForward;
exports.PageUpIcon = PageUp;
exports.PauseIcon = Pause;
exports.PauseOutlinedIcon = PauseOutlined;
exports.PhoneDefaultIcon = PhoneDefault;
exports.PhoneSpeakingIcon = PhoneSpeaking;
exports.PlayIcon = Play;
exports.PlayOutlinedIcon = PlayOutlined;
exports.PresentLiveContentIcon = PresentLiveContent;
exports.PresenterIcon = Presenter;
exports.PreviewIcon = Preview;
exports.PrintIcon = Print;
exports.RecordIcon = Record;
exports.RectangleIcon = Rectangle;
exports.RefreshIcon = Refresh;
exports.ReplayIcon = Replay;
exports.ReplayOutlinedIcon = ReplayOutlined;
exports.Rewind15SecsIcon = Rewind15Secs;
exports.RoundedPauseIcon = RoundedPause;
exports.RoundedPlayIcon = RoundedPlay;
exports.ScreenshareIcon = Screenshare;
exports.SearchIcon = Search;
exports.SearchFileIcon = SearchFile;
exports.SearchFolderIcon = SearchFolder;
exports.SearchSelectedIcon = SearchSelected;
exports.SendIcon = Send;
exports.SettingsIcon = Settings;
exports.ShareIcon = Share;
exports.SortIcon = Sort;
exports.StarDefaultIcon = StarDefault;
exports.StarSelectedIcon = StarSelected;
exports.StructureIcon = Structure;
exports.TextAlignCenterIcon = TextAlignCenter;
exports.TextAlignJustifyIcon = TextAlignJustify;
exports.TextAlignLeftIcon = TextAlignLeft;
exports.TextAlignRightIcon = TextAlignRight;
exports.TextBoldIcon = TextBold;
exports.TextColumnsIcon = TextColumns;
exports.TextImageLeftIcon = TextImageLeft;
exports.TextImageRightIcon = TextImageRight;
exports.TextItalicIcon = TextItalic;
exports.TextOrderedListIcon = TextOrderedList;
exports.TextStrikethroughIcon = TextStrikethrough;
exports.TextTableIcon = TextTable;
exports.TextUnderlineIcon = TextUnderline;
exports.TextUnorderedListIcon = TextUnorderedList;
exports.TimerIcon = Timer;
exports.TrashIcon = Trash;
exports.TrendingDownIcon = TrendingDown;
exports.TrendingUpIcon = TrendingUp;
exports.UnfullscreenIcon = Unfullscreen;
exports.UnlockedIcon = Unlocked;
exports.UploadIcon = Upload;
exports.UserDefaultIcon = UserDefault;
exports.UserGroupIcon = UserGroup;
exports.UserInviteIcon = UserInvite;
exports.VideoOffIcon = VideoOff;
exports.VideoOnIcon = VideoOn;
exports.ViewCardIcon = ViewCard;
exports.ViewGalleryIcon = ViewGallery;
exports.ViewGallerySelectedIcon = ViewGallerySelected;
exports.ViewListIcon = ViewList;
exports.VolumeHighIcon = VolumeHigh;
exports.VolumeHighOutlinedIcon = VolumeHighOutlined;
exports.VolumeLowIcon = VolumeLow;
exports.VolumeLowOutlinedIcon = VolumeLowOutlined;
exports.WarningIcon = Warning;
exports.WorkSpaceIcon = WorkSpace;
exports.ZoomInIcon = ZoomIn;
exports.ZoomOutIcon = ZoomOut;
//# sourceMappingURL=icons.js.map
